// Generated by Avo VERSION 172.19.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "JQg7GJLbHUBmiOTB89SI";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "KXvq6gAdP99SmfsgPEPH",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "aDA1SfVA6aXQablIZ7vn",
          "se": (new Date()).toISOString(),
          "so": "AeOzk37kN",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "KXvq6gAdP99SmfsgPEPH",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "aDA1SfVA6aXQablIZ7vn",
          "se": (new Date()).toISOString(),
          "so": "AeOzk37kN",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "aDA1SfVA6aXQablIZ7vn",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export const FileType = {
  'IMAGE': 'image',
  'AUDIO': 'audio',
  'VIDEO': 'video',
  'DOCUMENT': 'document',
  'SLIDE_DECK': 'slideDeck',
} as const;
export type FileTypeType = typeof FileType;
export type FileTypeValueType = FileTypeType[keyof FileTypeType];

export const PinComponentType = {
  'AUDIO': 'audio',
  'FORMULA': 'formula',
  'HOTSPOT': 'hotspot',
  'IMAGE': 'image',
  'SHAPE': 'shape',
  'SPINNER': 'spinner',
  'TABLE': 'table',
  'TEXT': 'text',
  'TIMER': 'timer',
  'TRAFFIC_LIGHT': 'traffic_light',
  'VIDEO': 'video',
  'ANSWER_AREA': 'answer_area',
  'LINE': 'line',
} as const;
export type PinComponentTypeType = typeof PinComponentType;
export type PinComponentTypeValueType = PinComponentTypeType[keyof PinComponentTypeType];

export const PinType = {
  'SLIDE': 'slide',
  'QUIZ': 'quiz',
  'VIDEO': 'video',
  'MIND_MAP': 'mind_map',
  'OPEN_QUESTION': 'open_question',
  'DRAG_AND_DROP': 'drag_and_drop',
  'POLL': 'poll',
  'MAP': 'map',
  'LINK': 'link',
} as const;
export type PinTypeType = typeof PinType;
export type PinTypeValueType = PinTypeType[keyof PinTypeType];

export const EditorVersion = {
  'V1': 'v1',
  'V2': 'v2',
} as const;
export type EditorVersionType = typeof EditorVersion;
export type EditorVersionValueType = EditorVersionType[keyof EditorVersionType];

export const PinCreationMethod = {
  'ITEM_SEARCH': 'item_search',
  'UPLOAD_IMAGE': 'upload_image',
  'UPLOAD_POWERPOINT': 'upload_powerpoint',
  'PASTE_URL': 'paste_url',
  'FAVORITES': 'favorites',
  'UPLOAD_VIDEO': 'upload_video',
  'CREATE_OWN': 'create_own',
  'PASTE_SLIDE': 'paste_slide',
  'GENERATE_WITH_AI': 'generate_with_ai',
} as const;
export type PinCreationMethodType = typeof PinCreationMethod;
export type PinCreationMethodValueType = PinCreationMethodType[keyof PinCreationMethodType];

export const MobileRedirectionChoice = {
  'CONTINUE_ON_MOBILE': 'continue_on_mobile',
  'SEND_LOGIN_EMAIL': 'send_login_email',
} as const;
export type MobileRedirectionChoiceType = typeof MobileRedirectionChoice;
export type MobileRedirectionChoiceValueType = MobileRedirectionChoiceType[keyof MobileRedirectionChoiceType];

export const AiToolType = {
  'DEBATE_TOPICS_CREATE': 'debate_topics_create',
  'GLOSSARY_CREATE': 'glossary_create',
  'LESSON_RECAP': 'lesson_recap',
  'RUBRIC_CREATE': 'rubric_create',
  'TASK_CREATE': 'task_create',
  'TEXT_REWRITE': 'text_rewrite',
  'TEXT_SUMMARIZE': 'text_summarize',
  'TEXT_TRANSLATE': 'text_translate',
  'WEBSITE_SUMMARIZE': 'website_summarize',
  'IMAGE_CREATE': 'image_create',
} as const;
export type AiToolTypeType = typeof AiToolType;
export type AiToolTypeValueType = AiToolTypeType[keyof AiToolTypeType];

export const SelectedPurpose = {
  'CREATE_INTERACTIVE_LESSON': 'create_interactive_lesson',
  'UPLOAD_POWERPOINT': 'upload_powerpoint',
  'READY_MADE_LESSON': 'ready_made_lesson',
  'REDEEM_VOUCHER': 'redeem_voucher',
  'EXPLORE_MYSELF': 'explore_myself',
} as const;
export type SelectedPurposeType = typeof SelectedPurpose;
export type SelectedPurposeValueType = SelectedPurposeType[keyof SelectedPurposeType];

export const AiInputMethod = {
  'TEXT_SHORT': 'text_short',
  'TEXT_LONG': 'text_long',
  'IMAGE': 'image',
} as const;
export type AiInputMethodType = typeof AiInputMethod;
export type AiInputMethodValueType = AiInputMethodType[keyof AiInputMethodType];

export const LoginMethod = {
  'CANVAS': 'canvas',
  'GOOGLE': 'google',
  'ITSLEARNING': 'itslearning',
  'MAGIC_LINK': 'magic_link',
  'OFFICE365': 'office365',
  'PASSWORD': 'password',
  'SOM': 'som',
  'SURFCONEXT': 'surfconext',
  'UNKNOWN': 'unknown',
} as const;
export type LoginMethodType = typeof LoginMethod;
export type LoginMethodValueType = LoginMethodType[keyof LoginMethodType];

export const RequestToJoinMethod = {
  'SCHOOL_PICKER': 'school_picker',
  'EMAIL_DOMAIN_SUGGESTION': 'email_domain_suggestion',
  'NAME_INPUT_MATCHING': 'name_input_matching',
} as const;
export type RequestToJoinMethodType = typeof RequestToJoinMethod;
export type RequestToJoinMethodValueType = RequestToJoinMethodType[keyof RequestToJoinMethodType];

export const GeneratorInputMethod = {
  'IMAGE': 'image',
  'TEXT': 'text',
} as const;
export type GeneratorInputMethodType = typeof GeneratorInputMethod;
export type GeneratorInputMethodValueType = GeneratorInputMethodType[keyof GeneratorInputMethodType];

export const PlayerComponentType = {
  'SPINNER': 'spinner',
  'TIMER': 'timer',
  'TRAFFIC_LIGHT': 'traffic_light',
} as const;
export type PlayerComponentTypeType = typeof PlayerComponentType;
export type PlayerComponentTypeValueType = PlayerComponentTypeType[keyof PlayerComponentTypeType];

export const OrganizationMatchMethod = {
  'EMAIL_DOMAIN': 'email_domain',
} as const;
export type OrganizationMatchMethodType = typeof OrganizationMatchMethod;
export type OrganizationMatchMethodValueType = OrganizationMatchMethodType[keyof OrganizationMatchMethodType];

export const PinComponentCreationMethod = {
  'CREATE_OWN': 'create_own',
  'ITEM_SEARCH': 'item_search',
  'PASTE_COMPONENT': 'paste_component',
} as const;
export type PinComponentCreationMethodType = typeof PinComponentCreationMethod;
export type PinComponentCreationMethodValueType = PinComponentCreationMethodType[keyof PinComponentCreationMethodType];

let SnowplowCustom: any;
let GoogleAnalytics4: any;
let MicrosoftUET: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    destinationOptions: any,
    SnowplowCustomDestination: CustomDestination,
    GoogleAnalytics4Destination: CustomDestination,
    MicrosoftUETDestination: CustomDestination) {
if (__AVO_ENV__ !== null) {
  return;
}
__AVO_ENV__ = options.env;
if (options.avoLogger !== undefined) {
  __AVO_LOGGER__ = options.avoLogger;
}
if (options.noop === true) {
  __AVO_NOOP__ = true;
}
if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
  InternalAvoLogger.warn("[avo] ****************************************************");
  InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
  InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
  InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
  InternalAvoLogger.warn("[avo] ****************************************************");
  __AVO_NOOP__ = false;
}
if (__AVO_NOOP__) {
  InternalAvoLogger.log("[avo] ****************************************************");
  InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
  InternalAvoLogger.log("[avo] - No events will be sent");
  InternalAvoLogger.log("[avo] - No network requests are made");
  InternalAvoLogger.log("[avo] ****************************************************");
}
if (options.strict !== undefined) {
  __STRICT__ = options.strict !== false;
}
if (options.reportFailureAs !== undefined) {
  __REPORT_FAILURE_AS__ = options.reportFailureAs;
}
__WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
if (!__AVO_NOOP__ && options.inspector !== undefined) {
  __INSPECTOR__ = options.inspector;
} else if (__AVO_ENV__ !== 'prod') {
  InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
}

destinationOptions = destinationOptions || {};

if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
  
}
if (!__AVO_NOOP__) {
  if (__AVO_ENV__ === AvoEnv.Prod) {
}
if (__AVO_ENV__ === AvoEnv.Dev) {
}

SnowplowCustom = SnowplowCustomDestination;
if (__AVO_ENV__ === 'prod') {
  SnowplowCustom && SnowplowCustom.make && SnowplowCustom.make(__AVO_ENV__, null);
} else if (__AVO_ENV__ === 'dev') {
  SnowplowCustom && SnowplowCustom.make && SnowplowCustom.make(__AVO_ENV__, null);
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Snowplow Custom. Head to destination settings in Avo to set a staging key.");
  SnowplowCustom && SnowplowCustom.make && SnowplowCustom.make(__AVO_ENV__, null);
}

GoogleAnalytics4 = GoogleAnalytics4Destination;
if (__AVO_ENV__ === 'prod') {
  GoogleAnalytics4 && GoogleAnalytics4.make && GoogleAnalytics4.make(__AVO_ENV__, "abcd");
} else if (__AVO_ENV__ === 'dev') {
  GoogleAnalytics4 && GoogleAnalytics4.make && GoogleAnalytics4.make(__AVO_ENV__, "defg");
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Google Analytics 4. Head to destination settings in Avo to set a staging key.");
  GoogleAnalytics4 && GoogleAnalytics4.make && GoogleAnalytics4.make(__AVO_ENV__, null);
}

MicrosoftUET = MicrosoftUETDestination;
if (__AVO_ENV__ === 'prod') {
  MicrosoftUET && MicrosoftUET.make && MicrosoftUET.make(__AVO_ENV__, null);
} else if (__AVO_ENV__ === 'dev') {
  MicrosoftUET && MicrosoftUET.make && MicrosoftUET.make(__AVO_ENV__, null);
} else {
  console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for Microsoft UET. Head to destination settings in Avo to set a staging key.");
  MicrosoftUET && MicrosoftUET.make && MicrosoftUET.make(__AVO_ENV__, null);
}
if (__AVO_ENV__ === AvoEnv.Dev) {
  // debug console in Avo
  _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
}
}
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
__AVO_LOGGER__ = avoLogger;
}

export interface RegistrationStartProperties {
  referralToken: string | null | undefined;
}
/**
 * registration_start: Triggered when the registration page loads 'onload' where the user provides their first, last name, email and creates a password. (image is confusing, as the button doesn't trigger this event, the page load does)
 * 
 * When to trigger this event:
 * 1. The registration funnel begins properly from the registration pages in lesson up. This starts on the page that enables you to complete your account details. The event triggers on page-load.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WpRIQzzcEw/trigger/dhIFNLBkJ
 * 
 * @param properties the properties associatied with this event
 * @param properties.referralToken: Token unique to each user, used in Teacher Referral events e.g. generate referral Link, Referred registration.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WpRIQzzcEw}
 */
export function registrationStart(properties: RegistrationStartProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.referralToken !== undefined && properties.referralToken !== null ?
  eventPropertiesArray.push({id: "FP0uPAxB7", name: "referral_token", value: properties.referralToken}) :
  eventPropertiesArray.push({id: "FP0uPAxB7", name: "referral_token", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "WpRIQzzcEw", "ae3668c10d97c1a41b64b0b9460c14f8477007e534b92dd36feca00caab78d7b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("registration_start", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("WpRIQzzcEw", "registration_start", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_start", eventProperties, "WpRIQzzcEw", "ae3668c10d97c1a41b64b0b9460c14f8477007e534b92dd36feca00caab78d7b");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("registration_start", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("registration_start", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("registration_start", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RegistrationUserSchoolChangeFormProperties {
  schoolName: string;
  city: string;
  schoolSuggestionId: string | null | undefined;
}
/**
 * registration_user_school_change_form: The user populates with free text their school name and its location or (only NL) the user selects a school suggestion from the list. 
 * 
 * When to trigger this event:
 * 1. When the user finishes this form and clicks 'let's get started' this event should be triggered including the school details populated in these free text boxes. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YuGbSeCNMU/trigger/t00olYRio
 * 2. The user selected / provided a school or they indicated they do not work at a school. Then they click the submit button. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YuGbSeCNMU/trigger/dX_pC4L6Z
 * 
 * @param properties the properties associatied with this event
 * @param properties.schoolName: Name of the school the user filled in

 * @param properties.city: Name of the city the user filled in
 * @param properties.schoolSuggestionId: The ID of the school from the school auto-suggestion dropdown.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YuGbSeCNMU}
 */
export function registrationUserSchoolChangeForm(properties: RegistrationUserSchoolChangeFormProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "t-u2sVzoF0", name: "school_name", value: properties.schoolName});
eventPropertiesArray.push({id: "APVPqXWuRA", name: "city", value: properties.city});
properties.schoolSuggestionId !== undefined && properties.schoolSuggestionId !== null ?
  eventPropertiesArray.push({id: "7fyNhm0tKQ", name: "school_suggestion_id", value: properties.schoolSuggestionId}) :
  eventPropertiesArray.push({id: "7fyNhm0tKQ", name: "school_suggestion_id", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "YuGbSeCNMU", "851c3558bd87d3d452090107295ba1c53a187fb2b1bf9470eae12c4df50d8e0f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("registration_user_school_change_form", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("YuGbSeCNMU", "registration_user_school_change_form", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_user_school_change_form", eventProperties, "YuGbSeCNMU", "851c3558bd87d3d452090107295ba1c53a187fb2b1bf9470eae12c4df50d8e0f");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("registration_user_school_change_form", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("registration_user_school_change_form", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("registration_user_school_change_form", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface CreateRegistrationAccountProperties {
  referralToken: string | null | undefined;
}
/**
 * create_registration_account: The point at which a user's account is created and the user has entered their name and accepted the terms and conditions. 

 * 
 * When to trigger this event:
 * 1. The event is fired when "continue" is clicked. At this point the account has been created, the user provided their name and they accepted the terms. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/xghfMf9H2N/trigger/o8W2mJHcJ
 * 
 * @param properties the properties associatied with this event
 * @param properties.referralToken: Token unique to each user, used in Teacher Referral events e.g. generate referral Link, Referred registration.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/xghfMf9H2N}
 */
export function createRegistrationAccount(properties: CreateRegistrationAccountProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.referralToken !== undefined && properties.referralToken !== null ?
  eventPropertiesArray.push({id: "FP0uPAxB7", name: "referral_token", value: properties.referralToken}) :
  eventPropertiesArray.push({id: "FP0uPAxB7", name: "referral_token", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "xghfMf9H2N", "6145f4e3db8c8807bd39fc58672602886ed8105724dd01be8b670c31c834f4cd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("create_registration_account", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("xghfMf9H2N", "create_registration_account", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("create_registration_account", eventProperties, "xghfMf9H2N", "6145f4e3db8c8807bd39fc58672602886ed8105724dd01be8b670c31c834f4cd");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("create_registration_account", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("create_registration_account", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("create_registration_account", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SubscriptionStartProperties {
  subscriptionType: string;
}
/**
 * subscription_start: User selects the start subscription button after entering their payment details to initiate the subscription. 
 * 
 * When to trigger this event:
 * 1. Clicking the button 'Start subscription' finishes the upgrade process to a pro license. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/FwytijnDlG/trigger/CVhnvl8nP
 * 
 * @param properties the properties associatied with this event
 * @param properties.subscriptionType: The type of license a user has, pro, free, school etc.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/FwytijnDlG}
 */
export function subscriptionStart(properties: SubscriptionStartProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "nqhmotGRNZ", name: "subscription_type", value: properties.subscriptionType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "FwytijnDlG", "8e51976f841550f90f7143a05e7085764c5e1a5917e26f6920feec4c74d400da", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("subscription_start", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("FwytijnDlG", "subscription_start", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("subscription_start", eventProperties, "FwytijnDlG", "8e51976f841550f90f7143a05e7085764c5e1a5917e26f6920feec4c74d400da");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("subscription_start", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("subscription_start", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("subscription_start", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SubscriptionSubtypeSelectProperties {
  subscriptionSubtype: string;
}
/**
 * subscription_subtype_select: The user selects whether they wish to be billed annually or monthly for their subscription. 
 * 
 * When to trigger this event:
 * 1. This event is triggered by the clicking of next step, following the user selecting annual subscription or monthly subscription for their subscription sub type. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/1pjC1FolQB/trigger/MqCKMjo03
 * 
 * @param properties the properties associatied with this event
 * @param properties.subscriptionSubtype: The selection of either monthly or yearly subscription type.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/1pjC1FolQB}
 */
export function subscriptionSubtypeSelect(properties: SubscriptionSubtypeSelectProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "9haiNv-TAG", name: "subscription_subtype", value: properties.subscriptionSubtype});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "1pjC1FolQB", "85397a800d6690cd182c399e67ae70497c477214e90691785b41f66f14683658", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("subscription_subtype_select", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("1pjC1FolQB", "subscription_subtype_select", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("subscription_subtype_select", eventProperties, "1pjC1FolQB", "85397a800d6690cd182c399e67ae70497c477214e90691785b41f66f14683658");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("subscription_subtype_select", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("subscription_subtype_select", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("subscription_subtype_select", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonCreateProperties {
  lessonId: string;
  editorVersion: EditorVersionValueType | null | undefined;
}
/**
 * lesson_create: This event occurs after a user clicks to create a new lesson, populates the lesson name field and clicks ok. 
 * 
 * When to trigger this event:
 * 1. A user selects the new lesson button on my lessons. And once populated the lesson name, they click ok. Which triggers this event. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/nJ5ZJLRyNQ/trigger/d_WFf7h52
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.editorVersion: This property helps distinguish events fired by the old editor vs. the new editor
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/nJ5ZJLRyNQ}
 */
export function lessonCreate(properties: LessonCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
properties.editorVersion !== undefined && properties.editorVersion !== null ?
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: properties.editorVersion}) :
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "nJ5ZJLRyNQ", "9c017dbb8d883103146e8f3b481db53950d952170fc303cd4ea1bc51de8ecf12", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("nJ5ZJLRyNQ", "lesson_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_create", eventProperties, "nJ5ZJLRyNQ", "9c017dbb8d883103146e8f3b481db53950d952170fc303cd4ea1bc51de8ecf12");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonTeachProperties {
  lessonId: string;
  assignmentId: string;
  editorVersion: EditorVersionValueType | null | undefined;
}
/**
 * lesson_teach: This event is the beginning of a lesson being taught
 * 
 * When to trigger this event:
 * 1. This event is triggered by selecting the teach button from within a lesson
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/KsT4_Cej8K/trigger/hwX9ctcb6
 * 2. This event can also be triggered by right clicking on a lesson and clicking teach.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/KsT4_Cej8K/trigger/WzmD24f9k
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.assignmentId: An assignment id is every unique instance of a lesson being taught, if the same lesson is taught twice this will result in 2 different assignment id's
 * @param properties.editorVersion: This property helps distinguish events fired by the old editor vs. the new editor
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/KsT4_Cej8K}
 */
export function lessonTeach(properties: LessonTeachProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "EB0CImeWls", name: "assignment_id", value: properties.assignmentId});
properties.editorVersion !== undefined && properties.editorVersion !== null ?
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: properties.editorVersion}) :
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "KsT4_Cej8K", "729f621608840fc34a4b1c473047b181f32ad7fc41b343d66a9990ea0c3ba513", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_teach", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("KsT4_Cej8K", "lesson_teach", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_teach", eventProperties, "KsT4_Cej8K", "729f621608840fc34a4b1c473047b181f32ad7fc41b343d66a9990ea0c3ba513");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_teach", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_teach", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_teach", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonStopPresentingProperties {
  studentCount: number;
  lessonId: string;
  lessonDuration: number;
  assignmentId: string;
  invitedClass: boolean;
  editorVersion: EditorVersionValueType | null | undefined;
}
/**
 * lesson_stop_presenting: When the user chooses to stop presenting the lesson.
 * 
 * When to trigger this event:
 * 1. Selecting the close button in the bottom corner of the lesson presentation. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/CCuCpwvpRD/trigger/NMvnEfB8g
 * 
 * @param properties the properties associatied with this event
 * @param properties.studentCount: The count of students displayed in lesson teach mode.
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.lessonDuration: The duration between the start and end of the lesson in seconds. This event is also used in the demo lesson during onboarding.
 * @param properties.assignmentId: An assignment id is every unique instance of a lesson being taught, if the same lesson is taught twice this will result in 2 different assignment id's
 * @param properties.invitedClass: Lesson was teached to an class
 * @param properties.editorVersion: This property helps distinguish events fired by the old editor vs. the new editor
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/CCuCpwvpRD}
 */
export function lessonStopPresenting(properties: LessonStopPresentingProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "d0xfZcDaWx", name: "student_count", value: properties.studentCount});
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "6OJe4naDtP", name: "lesson_duration", value: properties.lessonDuration});
eventPropertiesArray.push({id: "EB0CImeWls", name: "assignment_id", value: properties.assignmentId});
eventPropertiesArray.push({id: "CubEOH9E19", name: "invited_class", value: properties.invitedClass});
properties.editorVersion !== undefined && properties.editorVersion !== null ?
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: properties.editorVersion}) :
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "CCuCpwvpRD", "66e1f631ea25d5a4cce2773bae591613856cee08671f0029ac4dfcd420eeb2aa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_stop_presenting", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("CCuCpwvpRD", "lesson_stop_presenting", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_stop_presenting", eventProperties, "CCuCpwvpRD", "66e1f631ea25d5a4cce2773bae591613856cee08671f0029ac4dfcd420eeb2aa");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_stop_presenting", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_stop_presenting", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_stop_presenting", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonSaveForLaterProperties {
  lessonId: string;
}
/**
 * lesson_save_for_later: From the search, when a user selects a lesson they can save it to their lessons for later. This click of the select this folder that follows will trigger an event.
 * 
 * When to trigger this event:
 * 1. The selection of the button to save the lesson for later triggers the pop up of a selection of location. This should also trigger a save for later event. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YXM0WJrBAQ/trigger/wAXv8F3nd
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YXM0WJrBAQ}
 */
export function lessonSaveForLater(properties: LessonSaveForLaterProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "YXM0WJrBAQ", "0ffdbad1751fae2a0dacfff2a2fec99581fbfa97f23758c328bc7bb21e73c883", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_save_for_later", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("YXM0WJrBAQ", "lesson_save_for_later", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_save_for_later", eventProperties, "YXM0WJrBAQ", "0ffdbad1751fae2a0dacfff2a2fec99581fbfa97f23758c328bc7bb21e73c883");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_save_for_later", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_save_for_later", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_save_for_later", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * registration_completed: The point at which a registration is finished for a user, in either option of teaches at school or not in the flow. 
 * 
 * When to trigger this event:
 * 1. The first place this event can be triggered is by selecting I don't teach at a school and the button changes to Let's get started! once this button is selected the event should be triggered.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/oZ-AlzbYo6/trigger/krQwJtK1z
 * 2. This event should also be triggered when a user follows the types of education flow. The user will type a school name and city into this box. And then this can complete the registration as well. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/oZ-AlzbYo6/trigger/ZGmappOeZ
 * 3. Finally, this event can also be triggered by either selecting no thanks, or yes, send request on this page. This is the final step of the registration flow for a user that has filled in details of a school that already exists in the system. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/oZ-AlzbYo6/trigger/VBlfHNLmJ
 * 4. The user selected / provided a school or they indicated they do not work at a school. Then they click the submit button. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/oZ-AlzbYo6/trigger/Q4wPfrgne
 * 5. When user clicks create account after requesting to join a school during registration.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/oZ-AlzbYo6/trigger/K9DSIaD_h
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/oZ-AlzbYo6}
 */
export function registrationCompleted() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "oZ-AlzbYo6", "6982d862c976a6995463d5476ec63a74472542ffcb6f583895e71e819c987113", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("registration_completed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("oZ-AlzbYo6", "registration_completed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_completed", eventProperties, "oZ-AlzbYo6", "6982d862c976a6995463d5476ec63a74472542ffcb6f583895e71e819c987113");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("registration_completed", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("registration_completed", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("registration_completed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * teams_beta_open_form: A user clicked on try Teams Beta
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/di8AcwtXi9/trigger/C2QTs-Xav
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/di8AcwtXi9}
 */
export function teamsBetaOpenForm() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "di8AcwtXi9", "67a567bb8f7b3f0d3fb9f52210fcbcc1d02e3290f2d8570adc1c61ba31c4f87e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("teams_beta_open_form", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("di8AcwtXi9", "teams_beta_open_form", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("teams_beta_open_form", eventProperties, "di8AcwtXi9", "67a567bb8f7b3f0d3fb9f52210fcbcc1d02e3290f2d8570adc1c61ba31c4f87e");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("teams_beta_open_form", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("teams_beta_open_form", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("teams_beta_open_form", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonViewProperties {
  lessonId: string;
  channelId: string | null | undefined;
}
/**
 * lesson_view: When the users views a lesson from the catalog
 * 
 * When to trigger this event:
 * 1. When the user visits the lesson page in the search application
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ceJQnxGUgT/trigger/_do-rAeBB
 * 2. When the users visits a lesson via the channel page
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ceJQnxGUgT/trigger/0ed_VBE14
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.channelId: The unique identification of a Channel
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ceJQnxGUgT}
 */
export function lessonView(properties: LessonViewProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
properties.channelId !== undefined && properties.channelId !== null ?
  eventPropertiesArray.push({id: "w9KD4Iu9jk", name: "channel_id", value: properties.channelId}) :
  eventPropertiesArray.push({id: "w9KD4Iu9jk", name: "channel_id", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ceJQnxGUgT", "c6bd0d50a5c06b63b3dcf5b1acaee98c1b4b5a9319924359dd634231d7716092", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_view", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ceJQnxGUgT", "lesson_view", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_view", eventProperties, "ceJQnxGUgT", "c6bd0d50a5c06b63b3dcf5b1acaee98c1b4b5a9319924359dd634231d7716092");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_view", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_view", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_view", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonShareProperties {
  lessonId: string;
  editorVersion: EditorVersionValueType | null | undefined;
}
/**
 * lesson_share: When the user shares a lesson
 * 
 * When to trigger this event:
 * 1. Triggers when this popup is shown when a teacher presses share from his lesson editor or exporer.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WoKIcLvREv/trigger/sJVtU6B12
 * 2. Triggers when this popup is shown via the lesson detail page in the search when the users presses share
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WoKIcLvREv/trigger/T1DG4Rttl
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.editorVersion: This property helps distinguish events fired by the old editor vs. the new editor
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WoKIcLvREv}
 */
export function lessonShare(properties: LessonShareProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
properties.editorVersion !== undefined && properties.editorVersion !== null ?
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: properties.editorVersion}) :
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "WoKIcLvREv", "7424ffde0887dbfa1f7c1f420e517c026730f84e8f7c7bec40b069a9c5722d5e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_share", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("WoKIcLvREv", "lesson_share", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_share", eventProperties, "WoKIcLvREv", "7424ffde0887dbfa1f7c1f420e517c026730f84e8f7c7bec40b069a9c5722d5e");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_share", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_share", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_share", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonRenameProperties {
  lessonId: string;
  lessonName: string;
  editorVersion: EditorVersionValueType | null | undefined;
}
/**
 * lesson_rename: When the user renames a lesson
 * 
 * When to trigger this event:
 * 1. When the user clicks "ok" on the popup to rename the lesson
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/FKWcXEIXqz/trigger/Odqudoanz
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.lessonName: The name of a lesson as filled in by the teacher
 * @param properties.editorVersion: This property helps distinguish events fired by the old editor vs. the new editor
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/FKWcXEIXqz}
 */
export function lessonRename(properties: LessonRenameProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "W8l8VxwsA-", name: "lesson_name", value: properties.lessonName});
properties.editorVersion !== undefined && properties.editorVersion !== null ?
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: properties.editorVersion}) :
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "FKWcXEIXqz", "f1db03e0f45d5c84494d64ba41241ea7e55d1512a5c03f2b99841611a7637600", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_rename", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("FKWcXEIXqz", "lesson_rename", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_rename", eventProperties, "FKWcXEIXqz", "f1db03e0f45d5c84494d64ba41241ea7e55d1512a5c03f2b99841611a7637600");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_rename", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_rename", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_rename", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PinViewProperties {
  lessonId: string;
  pinId: string;
  teachingMode: boolean;
  pinType: PinTypeValueType;
}
/**
 * pin_view: When the user views a pin (slide) in the teacher app (excluding the editor)
 * 
 * When to trigger this event:
 * 1. When the user views a pin (slide) in the preview player which is opened when the user enlarges the preview icon of the lesson
initial load
when the users switches to another pin

player: preview
presentation-mode: true
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/aUfVziqh-X/trigger/LGId5xTY8
 * 2. When the users navigations through the realtime player which can be opened by pressing:
teach in the lesson editor
play at lesson detail

player: realtime
presentation-mode: true
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/aUfVziqh-X/trigger/eBbMC_KlO
 * 3. When the user opens the preview mode and views a pin there
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/aUfVziqh-X/trigger/rX7j3EEnK
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.pinId: The unique identification of a pin (slide) of a lesson
 * @param properties.teachingMode: Indicates if the user is in a teaching mode or not
 * @param properties.pinType: The type of pin. Lets you know whether the pin is a slide, or a video, or a quiz question.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/aUfVziqh-X}
 */
export function pinView(properties: PinViewProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "1w97oOCgL3", name: "pin_id", value: properties.pinId});
eventPropertiesArray.push({id: "QaaOlIu2T", name: "teaching_mode", value: properties.teachingMode});
eventPropertiesArray.push({id: "CN9KomkXod", name: "pin_type", value: properties.pinType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "aUfVziqh-X", "c6391869a2bd5634bfabbf0e2e334f5a35b749ecce99aebf73e505fa3462011a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("pin_view", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("aUfVziqh-X", "pin_view", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("pin_view", eventProperties, "aUfVziqh-X", "c6391869a2bd5634bfabbf0e2e334f5a35b749ecce99aebf73e505fa3462011a");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("pin_view", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("pin_view", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("pin_view", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ReportOpenProperties {
  lessonId: string;
  assignmentId: string;
}
/**
 * report_open: When the user opens a report
 * 
 * When to trigger this event:
 * 1. When the user clicks on one of the reports in the popup which is shown when the users clicks reports in the lesson editor 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Dbe_a9HqEe/trigger/MEC6mjmME
 * 2. When the users opens the report via the lesson results at my classes
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Dbe_a9HqEe/trigger/QrBOBjpLG
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.assignmentId: An assignment id is every unique instance of a lesson being taught, if the same lesson is taught twice this will result in 2 different assignment id's
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Dbe_a9HqEe}
 */
export function reportOpen(properties: ReportOpenProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "EB0CImeWls", name: "assignment_id", value: properties.assignmentId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Dbe_a9HqEe", "6fdd26a611812984567fe8c380b48ddc72091580b0d38770f4d620f09631f0e9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("report_open", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Dbe_a9HqEe", "report_open", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("report_open", eventProperties, "Dbe_a9HqEe", "6fdd26a611812984567fe8c380b48ddc72091580b0d38770f4d620f09631f0e9");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("report_open", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("report_open", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("report_open", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TestGradeProperties {
  lessonId: string;
  assignmentId: string;
}
/**
 * test_grade: When the teacher grades 
 * 
 * When to trigger this event:
 * 1. Occurs when a teacher hands out grades
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/wuy9oPMcU/trigger/XteAgg7M5
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.assignmentId: An assignment id is every unique instance of a lesson being taught, if the same lesson is taught twice this will result in 2 different assignment id's
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/wuy9oPMcU}
 */
export function testGrade(properties: TestGradeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "EB0CImeWls", name: "assignment_id", value: properties.assignmentId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "wuy9oPMcU", "d378ddd59e9272d0e4cc04408afd344ed24f66d10219f3a4ef083b5edff1cee8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("test_grade", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("wuy9oPMcU", "test_grade", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("test_grade", eventProperties, "wuy9oPMcU", "d378ddd59e9272d0e4cc04408afd344ed24f66d10219f3a4ef083b5edff1cee8");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("test_grade", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("test_grade", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("test_grade", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonOpenProperties {
  lessonId: string;
  editorVersion: EditorVersionValueType | null | undefined;
}
/**
 * lesson_open: When the users opens his lesson in his editor
 * 
 * When to trigger this event:
 * 1. When the user opens a lesson from his explorer
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ZNLV8iIjZG/trigger/HA3OEead-
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.editorVersion: This property helps distinguish events fired by the old editor vs. the new editor
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ZNLV8iIjZG}
 */
export function lessonOpen(properties: LessonOpenProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
properties.editorVersion !== undefined && properties.editorVersion !== null ?
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: properties.editorVersion}) :
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ZNLV8iIjZG", "919bf5c50af3336c526c971749a9bc699a811db52430db124fa9564cb27dfa22", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_open", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ZNLV8iIjZG", "lesson_open", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_open", eventProperties, "ZNLV8iIjZG", "919bf5c50af3336c526c971749a9bc699a811db52430db124fa9564cb27dfa22");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_open", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_open", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_open", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PinOpenProperties {
  pinId: string;
  lessonId: string;
  editorVersion: EditorVersionValueType | null | undefined;
}
/**
 * pin_open: When the user opens a pin (slide) in his editor
 * 
 * When to trigger this event:
 * 1. When a user switches from pin or when a pin has been selected when opening the editor
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/O6zXdMg1u3/trigger/JiJX1WWGu
 * 
 * @param properties the properties associatied with this event
 * @param properties.pinId: The unique identification of a pin (slide) of a lesson
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.editorVersion: This property helps distinguish events fired by the old editor vs. the new editor
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/O6zXdMg1u3}
 */
export function pinOpen(properties: PinOpenProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "1w97oOCgL3", name: "pin_id", value: properties.pinId});
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
properties.editorVersion !== undefined && properties.editorVersion !== null ?
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: properties.editorVersion}) :
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "O6zXdMg1u3", "2c3277ec322a26ae6ba7015203d5dc73acf57717f7c777149be040d20f314608", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("pin_open", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("O6zXdMg1u3", "pin_open", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("pin_open", eventProperties, "O6zXdMg1u3", "2c3277ec322a26ae6ba7015203d5dc73acf57717f7c777149be040d20f314608");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("pin_open", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("pin_open", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("pin_open", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * session_lock_view: When the teacher sees a session locked event
 * 
 * When to trigger this event:
 * 1. When a user logs in on multiple devices
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/PkCjaakFad/trigger/v1RETzKCB
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/PkCjaakFad}
 */
export function sessionLockView() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "PkCjaakFad", "c51a395acdc3a805888dd35708b5f356e87427abf14c8a238ba584dd380c409d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("session_lock_view", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("PkCjaakFad", "session_lock_view", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("session_lock_view", eventProperties, "PkCjaakFad", "c51a395acdc3a805888dd35708b5f356e87427abf14c8a238ba584dd380c409d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("session_lock_view", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("session_lock_view", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("session_lock_view", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * teams_beta_show_form: When we show the teams beta banner to users
 * 
 * When to trigger this event:
 * 1. Triggered in the explorer when we show the banner!
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/jQOs9ZS7Y4/trigger/-KVA5GfHz
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/jQOs9ZS7Y4}
 */
export function teamsBetaShowForm() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "jQOs9ZS7Y4", "b155cd4f0f9a6518b5495d24d3ab87734d8db6cddb13003ddec7d74ad285d89d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("teams_beta_show_form", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("jQOs9ZS7Y4", "teams_beta_show_form", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("teams_beta_show_form", eventProperties, "jQOs9ZS7Y4", "b155cd4f0f9a6518b5495d24d3ab87734d8db6cddb13003ddec7d74ad285d89d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("teams_beta_show_form", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("teams_beta_show_form", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("teams_beta_show_form", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationRequestToJoinAcceptedProperties {
  targetUserId: string | null | undefined;
  organizationId: string;
  licensesGivenCount: number;
}
/**
 * organization_request_to_join_accepted: An administrator accepts a join request to join a school
 * 
 * When to trigger this event:
 * 1. School admin clicks Accept or Accept and give license.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/CBMKj3cpEG/trigger/HnRo6hEkL
 * 
 * @param properties the properties associatied with this event
 * @param properties.targetUserId: The ID of a user when it isn't the user themselves performing an action. For instance when an administrator gives a teacher a license. The target_user_id is the user id of the teacher. The user_id of the event itself will be that of the administrator.
 * @param properties.organizationId: The id of the organization
 * @param properties.licensesGivenCount: The amount of licenses given. Will mostly be 1, but with a bulk import can be more than 1
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/CBMKj3cpEG}
 */
export function organizationRequestToJoinAccepted(properties: OrganizationRequestToJoinAcceptedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.targetUserId !== undefined && properties.targetUserId !== null ?
  eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: properties.targetUserId}) :
  eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: null});
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
eventPropertiesArray.push({id: "bN2RukVc7c", name: "licenses_given_count", value: properties.licensesGivenCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "CBMKj3cpEG", "caeacbb9ee5e2949abb35f852f0742d0f5fd834b140f3c300624ba449ea6c08a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("organization_request_to_join_accepted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("CBMKj3cpEG", "organization_request_to_join_accepted", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("organization_request_to_join_accepted", eventProperties, "CBMKj3cpEG", "caeacbb9ee5e2949abb35f852f0742d0f5fd834b140f3c300624ba449ea6c08a");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("organization_request_to_join_accepted", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("organization_request_to_join_accepted", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("organization_request_to_join_accepted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationInviteToJoinSentProperties {
  targetUserId: string | null | undefined;
  organizationId: string;
  licensesGivenCount: number;
  usersInvitedCount: number;
}
/**
 * organization_invite_to_join_sent: An administrator invites one or multiple users to join a school.
 * 
 * When to trigger this event:
 * 1. When admin adds a school member.

! There are 2 variants of this pop-up. 1 When a user is found and another when a user isn't found !
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/J4sCxoJUb_/trigger/hIFzgVDH8
 * 2. An administrator clicks the confirm import button. Whether assign a LessonUp school license is checked is irrelevant. The event is always fired.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/J4sCxoJUb_/trigger/iPpnds1LX
 * 
 * @param properties the properties associatied with this event
 * @param properties.targetUserId: The ID of a user when it isn't the user themselves performing an action. For instance when an administrator gives a teacher a license. The target_user_id is the user id of the teacher. The user_id of the event itself will be that of the administrator.
 * @param properties.organizationId: The id of the organization
 * @param properties.licensesGivenCount: The amount of licenses given. Will mostly be 1, but with a bulk import can be more than 1
 * @param properties.usersInvitedCount: The amount of users invited to an organization by an administrator. Will often be 1, but when imported in bulk it can be more.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/J4sCxoJUb_}
 */
export function organizationInviteToJoinSent(properties: OrganizationInviteToJoinSentProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.targetUserId !== undefined && properties.targetUserId !== null ?
  eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: properties.targetUserId}) :
  eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: null});
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
eventPropertiesArray.push({id: "bN2RukVc7c", name: "licenses_given_count", value: properties.licensesGivenCount});
eventPropertiesArray.push({id: "z2ioi_OskY", name: "users_invited_count", value: properties.usersInvitedCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "J4sCxoJUb_", "ef4ba3c625e6f8bda9252c2cef08e768af2d184b14a695c2397ec41d37ed5a64", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("organization_invite_to_join_sent", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("J4sCxoJUb_", "organization_invite_to_join_sent", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("organization_invite_to_join_sent", eventProperties, "J4sCxoJUb_", "ef4ba3c625e6f8bda9252c2cef08e768af2d184b14a695c2397ec41d37ed5a64");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("organization_invite_to_join_sent", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("organization_invite_to_join_sent", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("organization_invite_to_join_sent", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationLicenseGivenProperties {
  targetUserId: string | null | undefined;
  organizationId: string;
  licensesGivenCount: number;
}
/**
 * organization_license_given: An administrator assigns a teacher a seat, thereby giving them access to the school license.
 * 
 * When to trigger this event:
 * 1. Admin clicks give license in the member list.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WXKrlnfTkO/trigger/0HOrVxMmC
 * 2. Admin clicks 'Accept and give license' in the pending requests list.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WXKrlnfTkO/trigger/q0Bb1LuNd
 * 3. Admin invites a teacher with the "Assign a LessonUp school license" checked
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WXKrlnfTkO/trigger/QF1QRYBRy
 * 4. An administrator clicks "Confirm import" AND checkbox "Assign a LessonUp school license" is checked.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WXKrlnfTkO/trigger/MiyRrU03M
 * 
 * @param properties the properties associatied with this event
 * @param properties.targetUserId: The ID of a user when it isn't the user themselves performing an action. For instance when an administrator gives a teacher a license. The target_user_id is the user id of the teacher. The user_id of the event itself will be that of the administrator.
 * @param properties.organizationId: The id of the organization
 * @param properties.licensesGivenCount: The amount of licenses given. Will mostly be 1, but with a bulk import can be more than 1
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WXKrlnfTkO}
 */
export function organizationLicenseGiven(properties: OrganizationLicenseGivenProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.targetUserId !== undefined && properties.targetUserId !== null ?
  eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: properties.targetUserId}) :
  eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: null});
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
eventPropertiesArray.push({id: "bN2RukVc7c", name: "licenses_given_count", value: properties.licensesGivenCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "WXKrlnfTkO", "29604ebf81c0e32ca1e0d89412c725236e84dcd165f395217004d4a640a572f9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("organization_license_given", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("WXKrlnfTkO", "organization_license_given", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("organization_license_given", eventProperties, "WXKrlnfTkO", "29604ebf81c0e32ca1e0d89412c725236e84dcd165f395217004d4a640a572f9");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("organization_license_given", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("organization_license_given", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("organization_license_given", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationRequestToJoinRejectedProperties {
  targetUserId: string;
  organizationId: string;
}
/**
 * organization_request_to_join_rejected: An administrator rejects a teachers request to join the organization.
 * 
 * When to trigger this event:
 * 1. Admin rejects the join request from the pending requests list.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/0xkj_Xdl6/trigger/t2rsEasLZ
 * 
 * @param properties the properties associatied with this event
 * @param properties.targetUserId: The ID of a user when it isn't the user themselves performing an action. For instance when an administrator gives a teacher a license. The target_user_id is the user id of the teacher. The user_id of the event itself will be that of the administrator.
 * @param properties.organizationId: The id of the organization
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/0xkj_Xdl6}
 */
export function organizationRequestToJoinRejected(properties: OrganizationRequestToJoinRejectedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: properties.targetUserId});
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "0xkj_Xdl6", "44f3bd629fb5a712f6778917d881f448cb914dce4384927bfe98f8b19941faaa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("organization_request_to_join_rejected", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("0xkj_Xdl6", "organization_request_to_join_rejected", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("organization_request_to_join_rejected", eventProperties, "0xkj_Xdl6", "44f3bd629fb5a712f6778917d881f448cb914dce4384927bfe98f8b19941faaa");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("organization_request_to_join_rejected", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("organization_request_to_join_rejected", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("organization_request_to_join_rejected", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationMembershipRemovedProperties {
  targetUserId: string;
  organizationId: string;
  hadLicense: boolean;
}
/**
 * organization_membership_removed: An administrator removes a teacher from the organization entirely. Removing them from the list and from falling under the DPA agreement of the school.
 * 
 * When to trigger this event:
 * 1. Membership is removed from the member list from the school admin environment.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/NIol5gXslQ/trigger/Z6lZRS2J7
 * 
 * @param properties the properties associatied with this event
 * @param properties.targetUserId: The ID of a user when it isn't the user themselves performing an action. For instance when an administrator gives a teacher a license. The target_user_id is the user id of the teacher. The user_id of the event itself will be that of the administrator.
 * @param properties.organizationId: The id of the organization
 * @param properties.hadLicense: Is true when a user had a license and when their membership was removed
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/NIol5gXslQ}
 */
export function organizationMembershipRemoved(properties: OrganizationMembershipRemovedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: properties.targetUserId});
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
eventPropertiesArray.push({id: "Mx1sxl_FZ_", name: "had_license", value: properties.hadLicense});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "NIol5gXslQ", "c7cc0213327e9eb78283c4d1ca7a016fb411d6c138fa6b275e4c62f6039226fb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("organization_membership_removed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("NIol5gXslQ", "organization_membership_removed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("organization_membership_removed", eventProperties, "NIol5gXslQ", "c7cc0213327e9eb78283c4d1ca7a016fb411d6c138fa6b275e4c62f6039226fb");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("organization_membership_removed", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("organization_membership_removed", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("organization_membership_removed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationLicenseRemovedProperties {
  targetUserId: string;
  organizationId: string;
}
/**
 * organization_license_removed: An administrator removes a teachers license.
 * 
 * When to trigger this event:
 * 1. Remove a teacher from the member list.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ZJ9pwf4yuK/trigger/0RR6mjvt9
 * 
 * @param properties the properties associatied with this event
 * @param properties.targetUserId: The ID of a user when it isn't the user themselves performing an action. For instance when an administrator gives a teacher a license. The target_user_id is the user id of the teacher. The user_id of the event itself will be that of the administrator.
 * @param properties.organizationId: The id of the organization
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ZJ9pwf4yuK}
 */
export function organizationLicenseRemoved(properties: OrganizationLicenseRemovedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "UJHlLnvQVV", name: "target_user_id", value: properties.targetUserId});
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ZJ9pwf4yuK", "8859dd90bb916979caf25b73970991d303361beb2695c576c8024408fd71a6f4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("organization_license_removed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ZJ9pwf4yuK", "organization_license_removed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("organization_license_removed", eventProperties, "ZJ9pwf4yuK", "8859dd90bb916979caf25b73970991d303361beb2695c576c8024408fd71a6f4");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("organization_license_removed", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("organization_license_removed", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("organization_license_removed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TeacherRequestToJoinOrganizationSentProperties {
  organizationId: string;
  requestToJoinMethod: RequestToJoinMethodValueType;
}
/**
 * teacher_request_to_join_organization_sent: A teacher requests to join a school.
 * 
 * When to trigger this event:
 * 1. Clicking add on the pop-up when a matching school is found using a schoolname match. Triggered during registration.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YLOuEHZhJ7/trigger/VfRfUWzly
 * 2. Triggered from school page in the teacher admin environment.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YLOuEHZhJ7/trigger/A93hf6NfW
 * 3. Triggered when user requests to join from email domain match suggestion.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YLOuEHZhJ7/trigger/W9vqgSHcP
 * 
 * @param properties the properties associatied with this event
 * @param properties.organizationId: The id of the organization
 * @param properties.requestToJoinMethod: The method the user used to send their request to join the school.
e.g. schoolpicker, 
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YLOuEHZhJ7}
 */
export function teacherRequestToJoinOrganizationSent(properties: TeacherRequestToJoinOrganizationSentProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
eventPropertiesArray.push({id: "ecmfoqkKnT", name: "request_to_join_method", value: properties.requestToJoinMethod});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "YLOuEHZhJ7", "21dce1e35035ea00cda14f90b458fe7db53e13092abbba0c9049e2562ab667be", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("teacher_request_to_join_organization_sent", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("YLOuEHZhJ7", "teacher_request_to_join_organization_sent", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("teacher_request_to_join_organization_sent", eventProperties, "YLOuEHZhJ7", "21dce1e35035ea00cda14f90b458fe7db53e13092abbba0c9049e2562ab667be");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("teacher_request_to_join_organization_sent", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("teacher_request_to_join_organization_sent", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("teacher_request_to_join_organization_sent", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TeacherRequestToJoinOrganizationCanceledProperties {
  organizationId: string;
}
/**
 * teacher_request_to_join_organization_canceled: A teacher cancels his/her own request to join a school.
 * 
 * When to trigger this event:
 * 1. In the school page in the teacher account environment the user can cancel their own request to join a school. Event triggers after the confirmation pop-up.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/BEOtxXQT7n/trigger/OGafXYqdP
 * 
 * @param properties the properties associatied with this event
 * @param properties.organizationId: The id of the organization
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/BEOtxXQT7n}
 */
export function teacherRequestToJoinOrganizationCanceled(properties: TeacherRequestToJoinOrganizationCanceledProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "BEOtxXQT7n", "4711bf7ccedf0629a2c6e6a541c18c6d806de77d9023e8b98d8d59a895772573", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("teacher_request_to_join_organization_canceled", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("BEOtxXQT7n", "teacher_request_to_join_organization_canceled", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("teacher_request_to_join_organization_canceled", eventProperties, "BEOtxXQT7n", "4711bf7ccedf0629a2c6e6a541c18c6d806de77d9023e8b98d8d59a895772573");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("teacher_request_to_join_organization_canceled", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("teacher_request_to_join_organization_canceled", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("teacher_request_to_join_organization_canceled", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationLicensePurchasedProperties {
  licensesPurchasedCount: number;
  licensePricePerTeacher: number;
  organizationId: string;
}
/**
 * organization_license_purchased: An administrator purchases more license seats for their organization.
 * 
 * When to trigger this event:
 * 1. When admin clicks purchase now on the generated invoice. This is the last step of the "Request a quote" flow.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/--OHXAHb5_/trigger/t_AS2l5wy
 * 
 * @param properties the properties associatied with this event
 * @param properties.licensesPurchasedCount: The count of licenses purchased. Relevant when an administrator buys multiple license seats at once.
 * @param properties.licensePricePerTeacher: The price per license seat. Differs per organization based on the amount of seats they have and agreements made by sales.
 * @param properties.organizationId: The id of the organization
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/--OHXAHb5_}
 */
export function organizationLicensePurchased(properties: OrganizationLicensePurchasedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "yDdryMxXki", name: "licenses_purchased_count", value: properties.licensesPurchasedCount});
eventPropertiesArray.push({id: "81vZedGbZS", name: "license_price_per_teacher", value: properties.licensePricePerTeacher});
eventPropertiesArray.push({id: "rOZMxhfAPN", name: "organization_id", value: properties.organizationId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "--OHXAHb5_", "c403ba4e7ba33aa31a81c13d818100c1c0580b7281b436696f1ec3f46289e0d6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("organization_license_purchased", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("--OHXAHb5_", "organization_license_purchased", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("organization_license_purchased", eventProperties, "--OHXAHb5_", "c403ba4e7ba33aa31a81c13d818100c1c0580b7281b436696f1ec3f46289e0d6");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("organization_license_purchased", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("organization_license_purchased", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("organization_license_purchased", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OrganizationMatchSuggestedProperties {
  organizationMatchMethod: OrganizationMatchMethodValueType | null | undefined;
  organizationIdList: string[];
}
/**
 * organization_match_suggested: The user gets a suggestion to join a school based on their email address
 * 
 * When to trigger this event:
 * 1. In registration the event is fired when a match has been made and shown to the user. On page load.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/IpgBrV0iCJ/trigger/-NFr1PpRj
 * 
 * @param properties the properties associatied with this event
 * @param properties.organizationMatchMethod: The method used to match a user to an organization
 * @param properties.organizationIdList: Organization IDs when multiple organizations are possible.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/IpgBrV0iCJ}
 */
export function organizationMatchSuggested(properties: OrganizationMatchSuggestedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
properties.organizationMatchMethod !== undefined && properties.organizationMatchMethod !== null ?
  eventPropertiesArray.push({id: "qs0CrVd5r_", name: "organization_match_method", value: properties.organizationMatchMethod}) :
  eventPropertiesArray.push({id: "qs0CrVd5r_", name: "organization_match_method", value: null});
eventPropertiesArray.push({id: "K63Ar16BpW", name: "organization_id_list", value: properties.organizationIdList});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "IpgBrV0iCJ", "499feae73a0a8c98b9aa39f268468a2fbeb067f7c556fc6e94bdd5dd04f54444", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("organization_match_suggested", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("IpgBrV0iCJ", "organization_match_suggested", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("organization_match_suggested", eventProperties, "IpgBrV0iCJ", "499feae73a0a8c98b9aa39f268468a2fbeb067f7c556fc6e94bdd5dd04f54444");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("organization_match_suggested", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("organization_match_suggested", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("organization_match_suggested", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TeacherRegistrationPurposeSelectedProperties {
  selectedPurpose: SelectedPurposeValueType;
}
/**
 * teacher_registration_purpose_selected: The teacher has selected a purpose in the registration
 * 
 * When to trigger this event:
 * 1. Triggers when the user clicks continue on the purpose step
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/T0Pk9bY9Q_/trigger/0rtlsOXBP
 * 
 * @param properties the properties associatied with this event
 * @param properties.selectedPurpose: The purpose a user selected in the purpose step in registration.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/T0Pk9bY9Q_}
 */
export function teacherRegistrationPurposeSelected(properties: TeacherRegistrationPurposeSelectedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "SBBy88OsF8", name: "selected_purpose", value: properties.selectedPurpose});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "T0Pk9bY9Q_", "9c50f07f56abf270873159fd34213b772561bb4b2b8071d7cb6912664dff3360", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("teacher_registration_purpose_selected", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("T0Pk9bY9Q_", "teacher_registration_purpose_selected", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("teacher_registration_purpose_selected", eventProperties, "T0Pk9bY9Q_", "9c50f07f56abf270873159fd34213b772561bb4b2b8071d7cb6912664dff3360");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("teacher_registration_purpose_selected", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("teacher_registration_purpose_selected", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("teacher_registration_purpose_selected", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * onboarding_lesson_demo_prompted: The user is prompted to see the demo lesson.
 * 
 * When to trigger this event:
 * 1. After a successful registration we give the user the option to start a demo lesson.

The event is fired on page-load
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Cryg-ix5Ux/trigger/PwurJuUVA
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Cryg-ix5Ux}
 */
export function onboardingLessonDemoPrompted() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Cryg-ix5Ux", "404d3ed7ba76336a3dc981c14c4a98068f1f45b2027a8c2971ff64695c9582ac", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("onboarding_lesson_demo_prompted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Cryg-ix5Ux", "onboarding_lesson_demo_prompted", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("onboarding_lesson_demo_prompted", eventProperties, "Cryg-ix5Ux", "404d3ed7ba76336a3dc981c14c4a98068f1f45b2027a8c2971ff64695c9582ac");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("onboarding_lesson_demo_prompted", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("onboarding_lesson_demo_prompted", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("onboarding_lesson_demo_prompted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * onboarding_lesson_demo_started: The user starts the demo lesson during onboarding
 * 
 * When to trigger this event:
 * 1. The user clicks on Demo lesson. The event is fired when the lesson player is loaded.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/uFcS3gzYm4/trigger/Kpdc0yfTk
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/uFcS3gzYm4}
 */
export function onboardingLessonDemoStarted() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "uFcS3gzYm4", "81211a47955599c1fb5a487f2f294a9037bcbc48e1e2fe1bd88e26c8293efe45", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("onboarding_lesson_demo_started", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("uFcS3gzYm4", "onboarding_lesson_demo_started", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("onboarding_lesson_demo_started", eventProperties, "uFcS3gzYm4", "81211a47955599c1fb5a487f2f294a9037bcbc48e1e2fe1bd88e26c8293efe45");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("onboarding_lesson_demo_started", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("onboarding_lesson_demo_started", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("onboarding_lesson_demo_started", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface OnboardingLessonDemoClosedProperties {
  lessonDuration: number;
  studentCount: number;
  pinsViewed: number;
  totalPinCount: number;
}
/**
 * onboarding_lesson_demo_closed: The onboarding lesson demo is closed or when the browser is closed or someone leaves the page. Based on slide count and total slide count it is possible to calculate lesson completion %.
 * 
 * When to trigger this event:
 * 1. User closes the lesson demo
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/jKBS7kM6vf/trigger/P6ooV_DFu
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonDuration: The duration between the start and end of the lesson in seconds. This event is also used in the demo lesson during onboarding.
 * @param properties.studentCount: The count of students displayed in lesson teach mode.
 * @param properties.pinsViewed: The amount of views pinned during a lesson presentation
 * @param properties.totalPinCount: The total amount of slides in a lesson.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/jKBS7kM6vf}
 */
export function onboardingLessonDemoClosed(properties: OnboardingLessonDemoClosedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "6OJe4naDtP", name: "lesson_duration", value: properties.lessonDuration});
eventPropertiesArray.push({id: "d0xfZcDaWx", name: "student_count", value: properties.studentCount});
eventPropertiesArray.push({id: "cFeaeqTiUm", name: "pins_viewed", value: properties.pinsViewed});
eventPropertiesArray.push({id: "3x5vYiHN9W", name: "total_pin_count", value: properties.totalPinCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "jKBS7kM6vf", "1f6abdec6d80286340f2c1f033ad2066e0fca2cb9bebf0e7696c1ff825b0f4c0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("onboarding_lesson_demo_closed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("jKBS7kM6vf", "onboarding_lesson_demo_closed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("onboarding_lesson_demo_closed", eventProperties, "jKBS7kM6vf", "1f6abdec6d80286340f2c1f033ad2066e0fca2cb9bebf0e7696c1ff825b0f4c0");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("onboarding_lesson_demo_closed", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("onboarding_lesson_demo_closed", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("onboarding_lesson_demo_closed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface MobileRedirectionReactionProperties {
  mobileRedirectionChoice: MobileRedirectionChoiceValueType;
}
/**
 * mobile_redirection_reaction: Mobile users that visit the explorer or editor get prompted to move to desktop. 
 * 
 * When to trigger this event:
 * 1. Event is triggered when user clicks on the button "Continue to desktop" and the follow-up pop-up is displayed.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/k1TkChLLha/trigger/A4DD0osrL
 * 
 * @param properties the properties associatied with this event
 * @param properties.mobileRedirectionChoice: The choice a user makes when seeing this pop-up
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/k1TkChLLha}
 */
export function mobileRedirectionReaction(properties: MobileRedirectionReactionProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "LaaOkvU4KS", name: "mobile_redirection_choice", value: properties.mobileRedirectionChoice});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "k1TkChLLha", "1bd00b46e000ba3399f3f8ac8e3aae834e17d602dbe4fa63c353492b05c14300", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("mobile_redirection_reaction", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("k1TkChLLha", "mobile_redirection_reaction", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("mobile_redirection_reaction", eventProperties, "k1TkChLLha", "1bd00b46e000ba3399f3f8ac8e3aae834e17d602dbe4fa63c353492b05c14300");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("mobile_redirection_reaction", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("mobile_redirection_reaction", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("mobile_redirection_reaction", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PinCreateProperties {
  pinType: PinTypeValueType;
  lessonId: string;
  pinCreationMethod: PinCreationMethodValueType;
  editorVersion: EditorVersionValueType | null | undefined;
}
/**
 * pin_create: The user create a pin (slide)
 * 
 * When to trigger this event:
 * 1. User clicks "zelf maken" when adding a slide. It does not trigger when a user adds a slide through item search or favourites. It needs to be a new slide.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Me3ZEsVpE7/trigger/8Rus0g9js
 * 
 * @param properties the properties associatied with this event
 * @param properties.pinType: The type of pin. Lets you know whether the pin is a slide, or a video, or a quiz question.
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.pinCreationMethod: The method the user used to create the pin (slide). For instance through the powerpoint upload, creating a new slide, 
 * @param properties.editorVersion: This property helps distinguish events fired by the old editor vs. the new editor
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Me3ZEsVpE7}
 */
export function pinCreate(properties: PinCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CN9KomkXod", name: "pin_type", value: properties.pinType});
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "HN9l5JVlGe", name: "pin_creation_method", value: properties.pinCreationMethod});
properties.editorVersion !== undefined && properties.editorVersion !== null ?
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: properties.editorVersion}) :
  eventPropertiesArray.push({id: "CjTHxu5S7N", name: "editor_version", value: null});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Me3ZEsVpE7", "6e438c164375885d449118cfc604b904fd5bcd88405ee79c9aa5a8474329f464", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("pin_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Me3ZEsVpE7", "pin_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("pin_create", eventProperties, "Me3ZEsVpE7", "6e438c164375885d449118cfc604b904fd5bcd88405ee79c9aa5a8474329f464");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("pin_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("pin_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("pin_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * teacher_registration_hard_prompt: The teachers sees a pop-up when trying to teach while not logged in.
 * 
 * When to trigger this event:
 * 1. When users is shown the pop-up
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/XKvZoLjJRa/trigger/TKQxZ9Owl
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/XKvZoLjJRa}
 */
export function teacherRegistrationHardPrompt() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "XKvZoLjJRa", "fe86245760888a32c6a3eca1edc5f4034977647570120d498615c1c35f213492", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("teacher_registration_hard_prompt", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("XKvZoLjJRa", "teacher_registration_hard_prompt", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("teacher_registration_hard_prompt", eventProperties, "XKvZoLjJRa", "fe86245760888a32c6a3eca1edc5f4034977647570120d498615c1c35f213492");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("teacher_registration_hard_prompt", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("teacher_registration_hard_prompt", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("teacher_registration_hard_prompt", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * teacher_registration_medium_prompt: The teachers sees a pop-up after teaching a lesson an X amount of times whilst not logged in within the same session.
 * 
 * When to trigger this event:
 * 1. When users is shown the pop-up
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/HhktOQVoy/trigger/_Z4-c_ke5t
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/HhktOQVoy}
 */
export function teacherRegistrationMediumPrompt() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "HhktOQVoy", "0d4d309309c26b374e76415f11cdc8a8f850a9fcc5112ef3ec634594646e248a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("teacher_registration_medium_prompt", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("HhktOQVoy", "teacher_registration_medium_prompt", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("teacher_registration_medium_prompt", eventProperties, "HhktOQVoy", "0d4d309309c26b374e76415f11cdc8a8f850a9fcc5112ef3ec634594646e248a");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("teacher_registration_medium_prompt", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("teacher_registration_medium_prompt", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("teacher_registration_medium_prompt", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * experiment_ai_generation_started: Triggered when a user starts the flow to generate a quiz question
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/wT4LIdy20P}
 */
export function experimentAiGenerationStarted() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "wT4LIdy20P", "9a8157cb519ffe13d5e4895582aa11a3da9c43b3504c50a795b495ec400d13ca", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_generation_started", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("wT4LIdy20P", "experiment_ai_generation_started", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_generation_started", eventProperties, "wT4LIdy20P", "9a8157cb519ffe13d5e4895582aa11a3da9c43b3504c50a795b495ec400d13ca");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_generation_started", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_generation_started", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_generation_started", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ExperimentAiGenerationFailedProperties {
  pinType: PinTypeValueType;
  pinCount: number;
}
/**
 * experiment_ai_generation_failed: Fired when the ai generation fails of lesson items like quiz and poll.
 * 
 * @param properties the properties associatied with this event
 * @param properties.pinType: The type of pin. Lets you know whether the pin is a slide, or a video, or a quiz question.
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/BVve-xRBea}
 */
export function experimentAiGenerationFailed(properties: ExperimentAiGenerationFailedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CN9KomkXod", name: "pin_type", value: properties.pinType});
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "BVve-xRBea", "b0d200c772f68c0f85b7477ee2db39d29f79ae13b421627c512a7e59f0b63c86", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_generation_failed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("BVve-xRBea", "experiment_ai_generation_failed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_generation_failed", eventProperties, "BVve-xRBea", "b0d200c772f68c0f85b7477ee2db39d29f79ae13b421627c512a7e59f0b63c86");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_generation_failed", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_generation_failed", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_generation_failed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ExperimentAiGenerationSuccessProperties {
  pinType: PinTypeValueType;
  pinCount: number;
}
/**
 * experiment_ai_generation_success: Triggered when an ai generation succeeds
 * 
 * @param properties the properties associatied with this event
 * @param properties.pinType: The type of pin. Lets you know whether the pin is a slide, or a video, or a quiz question.
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Vfxx15RTfk}
 */
export function experimentAiGenerationSuccess(properties: ExperimentAiGenerationSuccessProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CN9KomkXod", name: "pin_type", value: properties.pinType});
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Vfxx15RTfk", "4594584582717a07058017d482d242795a159bad3c8f186eadb5970231dcc008", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_generation_success", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Vfxx15RTfk", "experiment_ai_generation_success", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_generation_success", eventProperties, "Vfxx15RTfk", "4594584582717a07058017d482d242795a159bad3c8f186eadb5970231dcc008");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_generation_success", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_generation_success", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_generation_success", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ExperimentAiGenerationPromptSuccessProperties {
  pinCount: number;
  pinType: PinTypeValueType;
  openAiPrompt: string;
}
/**
 * experiment_ai_generation_prompt_success: The prompt if the user successfully finished the flow of generating lesson items like quiz and poll.
 * 
 * @param properties the properties associatied with this event
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * @param properties.pinType: The type of pin. Lets you know whether the pin is a slide, or a video, or a quiz question.
 * @param properties.openAiPrompt: The prompt entered by the user in the generation process
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/O5WNIw6t1}
 */
export function experimentAiGenerationPromptSuccess(properties: ExperimentAiGenerationPromptSuccessProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
eventPropertiesArray.push({id: "CN9KomkXod", name: "pin_type", value: properties.pinType});
eventPropertiesArray.push({id: "BCl0kY9Tze", name: "open_ai_prompt", value: properties.openAiPrompt});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "O5WNIw6t1", "613844f4d070c9d1d62ee0b380a86bebb3ab258afcc7c70eeb6e9c83e7665155", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_generation_prompt_success", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("O5WNIw6t1", "experiment_ai_generation_prompt_success", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_generation_prompt_success", eventProperties, "O5WNIw6t1", "613844f4d070c9d1d62ee0b380a86bebb3ab258afcc7c70eeb6e9c83e7665155");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_generation_prompt_success", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_generation_prompt_success", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_generation_prompt_success", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ExperimentAiGenerationPromptDiscardedProperties {
  pinType: PinTypeValueType;
  openAiPrompt: string;
}
/**
 * experiment_ai_generation_prompt_discarded: The prompt if the user discarded the generated results of lesson items like quiz and poll.
 * 
 * @param properties the properties associatied with this event
 * @param properties.pinType: The type of pin. Lets you know whether the pin is a slide, or a video, or a quiz question.
 * @param properties.openAiPrompt: The prompt entered by the user in the generation process
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/MyVTA1X9Vg}
 */
export function experimentAiGenerationPromptDiscarded(properties: ExperimentAiGenerationPromptDiscardedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "CN9KomkXod", name: "pin_type", value: properties.pinType});
eventPropertiesArray.push({id: "BCl0kY9Tze", name: "open_ai_prompt", value: properties.openAiPrompt});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "MyVTA1X9Vg", "67e42942ef2da8b5ca3565e3dcae17034c369b6b4ae3c132ea023b89bccb2b7d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_generation_prompt_discarded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("MyVTA1X9Vg", "experiment_ai_generation_prompt_discarded", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_generation_prompt_discarded", eventProperties, "MyVTA1X9Vg", "67e42942ef2da8b5ca3565e3dcae17034c369b6b4ae3c132ea023b89bccb2b7d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_generation_prompt_discarded", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_generation_prompt_discarded", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_generation_prompt_discarded", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * experiment_ai_lesson_generation_failed: fired when the lesson generation fails
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ldaBYytDeE}
 */
export function experimentAiLessonGenerationFailed() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ldaBYytDeE", "335850295990cd6eb9b94f210b1fbd28231e2d0cdfdd66f65021b3590d0471ff", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_lesson_generation_failed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ldaBYytDeE", "experiment_ai_lesson_generation_failed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_lesson_generation_failed", eventProperties, "ldaBYytDeE", "335850295990cd6eb9b94f210b1fbd28231e2d0cdfdd66f65021b3590d0471ff");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_lesson_generation_failed", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_lesson_generation_failed", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_lesson_generation_failed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ExperimentAiLessonGenerationSuccessProperties {
  pinCount: number;
}
/**
 * experiment_ai_lesson_generation_success: Fired when the lesson generation is a successful, even if the user doesn't want to use the generated lesson
 * 
 * @param properties the properties associatied with this event
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Gj5TEFW3eu}
 */
export function experimentAiLessonGenerationSuccess(properties: ExperimentAiLessonGenerationSuccessProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Gj5TEFW3eu", "db75284f184f97da38b921597dad0773059c5eb3e7eb2eb4c79afd02c2759f7d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_lesson_generation_success", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Gj5TEFW3eu", "experiment_ai_lesson_generation_success", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_lesson_generation_success", eventProperties, "Gj5TEFW3eu", "db75284f184f97da38b921597dad0773059c5eb3e7eb2eb4c79afd02c2759f7d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_lesson_generation_success", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_lesson_generation_success", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_lesson_generation_success", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * experiment_ai_lesson_generation_started: Fired when the lesson generation modal has opened, the users starts with the flow.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Stbn-KJkZ3}
 */
export function experimentAiLessonGenerationStarted() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Stbn-KJkZ3", "54a8ae376817e66fc42ed90458ac5edd373d276ca3f0fb4f146decaa05f0b2ef", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_lesson_generation_started", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Stbn-KJkZ3", "experiment_ai_lesson_generation_started", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_lesson_generation_started", eventProperties, "Stbn-KJkZ3", "54a8ae376817e66fc42ed90458ac5edd373d276ca3f0fb4f146decaa05f0b2ef");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_lesson_generation_started", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_lesson_generation_started", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_lesson_generation_started", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ExperimentAiLessonGenerationPromptDiscardedProperties {
  openAiPrompt: string;
}
/**
 * experiment_ai_lesson_generation_prompt_discarded: Fired when the lesson prompt is discarded
 * 
 * @param properties the properties associatied with this event
 * @param properties.openAiPrompt: The prompt entered by the user in the generation process
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/WP9N-jooy_}
 */
export function experimentAiLessonGenerationPromptDiscarded(properties: ExperimentAiLessonGenerationPromptDiscardedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "BCl0kY9Tze", name: "open_ai_prompt", value: properties.openAiPrompt});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "WP9N-jooy_", "ff6a872c0e091fe08f59f553955bfd42a62460913392262dc3a6b260f7807d5f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_lesson_generation_prompt_discarded", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("WP9N-jooy_", "experiment_ai_lesson_generation_prompt_discarded", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_lesson_generation_prompt_discarded", eventProperties, "WP9N-jooy_", "ff6a872c0e091fe08f59f553955bfd42a62460913392262dc3a6b260f7807d5f");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_lesson_generation_prompt_discarded", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_lesson_generation_prompt_discarded", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_lesson_generation_prompt_discarded", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ExperimentAiLessonPromptSuccessProperties {
  openAiPrompt: string;
  pinCount: number;
}
/**
 * experiment_ai_lesson_prompt_success: Fired when the lesson prompt is accepted
 * 
 * @param properties the properties associatied with this event
 * @param properties.openAiPrompt: The prompt entered by the user in the generation process
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ZuF2EI4Lcx}
 */
export function experimentAiLessonPromptSuccess(properties: ExperimentAiLessonPromptSuccessProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "BCl0kY9Tze", name: "open_ai_prompt", value: properties.openAiPrompt});
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ZuF2EI4Lcx", "46696f8f0c868cd31d18b00d5d941f1caa5ee49d2e6da57c29e8360ea12ad68d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("experiment_ai_lesson_prompt_success", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ZuF2EI4Lcx", "experiment_ai_lesson_prompt_success", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("experiment_ai_lesson_prompt_success", eventProperties, "ZuF2EI4Lcx", "46696f8f0c868cd31d18b00d5d941f1caa5ee49d2e6da57c29e8360ea12ad68d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("experiment_ai_lesson_prompt_success", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("experiment_ai_lesson_prompt_success", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("experiment_ai_lesson_prompt_success", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface UploadProperties {
  fileType: FileTypeValueType;
  fileExtension: string;
}
/**
 * upload: This event is triggered when a teacher uploads a new file to their account
 * 
 * When to trigger this event:
 * 1. This is triggered when the user uploads a file. It can be triggered in multiple places. The uploads page itself and in the editor.

IMAGE SHOULD BE UPDATED
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/OgEvym5_RH/trigger/nV55QV98I
 * 
 * @param properties the properties associatied with this event
 * @param properties.fileType: The type of file a user uploaded. The available types are 'image', 'audio', 'video' or 'document'.

 * @param properties.fileExtension: An upload document file extension. Examples are 'ppt', 'pdf' or 'png'.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/OgEvym5_RH}
 */
export function upload(properties: UploadProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "3XMT86sPQ", name: "file_type", value: properties.fileType});
eventPropertiesArray.push({id: "ipHbQO_zT", name: "file_extension", value: properties.fileExtension});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "OgEvym5_RH", "503fbea431bc4c67d4a556a1ed8145ace1ace0be6275fc861dedd137ac5c1612", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("upload", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("OgEvym5_RH", "upload", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("upload", eventProperties, "OgEvym5_RH", "503fbea431bc4c67d4a556a1ed8145ace1ace0be6275fc861dedd137ac5c1612");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("upload", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("upload", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("upload", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * lesson_generator_opened: Triggers when the user opens the lesson generator (modal)
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/3e9qI2hRDL}
 */
export function lessonGeneratorOpened() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3e9qI2hRDL", "14782de7912c1eb522f67cd4af4d8417ac47a2459d563524d3c6897aad527636", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_generator_opened", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3e9qI2hRDL", "lesson_generator_opened", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_generator_opened", eventProperties, "3e9qI2hRDL", "14782de7912c1eb522f67cd4af4d8417ac47a2459d563524d3c6897aad527636");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_generator_opened", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_generator_opened", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_generator_opened", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonGeneratorOutlineGeneratedProperties {
  promptLength: number;
  generatorInputMethod: GeneratorInputMethodValueType;
}
/**
 * lesson_generator_outline_generated: Triggers when an outline of a lesson has been generated and presented to the user
 * 
 * @param properties the properties associatied with this event
 * @param properties.promptLength: The number of characters of the text prompt
 * @param properties.generatorInputMethod: Kind of input a user can use to generate lessons. A user has the possibility to upload images (photos of a book) or provide a text themselves
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/bSzvDtikYj}
 */
export function lessonGeneratorOutlineGenerated(properties: LessonGeneratorOutlineGeneratedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
eventPropertiesArray.push({id: "fsFXfrOPBe", name: "generator_input_method", value: properties.generatorInputMethod});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "bSzvDtikYj", "3012aa2fdbbf48fc452aa3215c944244cb066dea1d5ebdd770a7009cb6db4167", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_generator_outline_generated", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("bSzvDtikYj", "lesson_generator_outline_generated", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_generator_outline_generated", eventProperties, "bSzvDtikYj", "3012aa2fdbbf48fc452aa3215c944244cb066dea1d5ebdd770a7009cb6db4167");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_generator_outline_generated", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_generator_outline_generated", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_generator_outline_generated", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonGeneratorOutlineGenerationFailedProperties {
  generatorInputMethod: GeneratorInputMethodValueType;
  promptLength: number;
}
/**
 * lesson_generator_outline_generation_failed: Triggers when we can't generate the outline for a lesson
 * 
 * @param properties the properties associatied with this event
 * @param properties.generatorInputMethod: Kind of input a user can use to generate lessons. A user has the possibility to upload images (photos of a book) or provide a text themselves
 * @param properties.promptLength: The number of characters of the text prompt
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/qKpTn51Q-P}
 */
export function lessonGeneratorOutlineGenerationFailed(properties: LessonGeneratorOutlineGenerationFailedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "fsFXfrOPBe", name: "generator_input_method", value: properties.generatorInputMethod});
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "qKpTn51Q-P", "ce8619ca19b9a9cca408fdb947216d88a572cdb34ef53da989ef8a1afc5e3608", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_generator_outline_generation_failed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("qKpTn51Q-P", "lesson_generator_outline_generation_failed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_generator_outline_generation_failed", eventProperties, "qKpTn51Q-P", "ce8619ca19b9a9cca408fdb947216d88a572cdb34ef53da989ef8a1afc5e3608");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_generator_outline_generation_failed", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_generator_outline_generation_failed", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_generator_outline_generation_failed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonGeneratorOverviewGeneratedProperties {
  generatorInputMethod: GeneratorInputMethodValueType;
  pinCount: number;
}
/**
 * lesson_generator_overview_generated: Triggers when the overview of a lesson has been generated with the lesson outline as its input.
 * 
 * @param properties the properties associatied with this event
 * @param properties.generatorInputMethod: Kind of input a user can use to generate lessons. A user has the possibility to upload images (photos of a book) or provide a text themselves
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ZICHmMJdeu}
 */
export function lessonGeneratorOverviewGenerated(properties: LessonGeneratorOverviewGeneratedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "fsFXfrOPBe", name: "generator_input_method", value: properties.generatorInputMethod});
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ZICHmMJdeu", "5915affd9279a9734c4b29b38bf35bb0f3d3022c1ca90db5b7243bedadeccddc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_generator_overview_generated", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ZICHmMJdeu", "lesson_generator_overview_generated", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_generator_overview_generated", eventProperties, "ZICHmMJdeu", "5915affd9279a9734c4b29b38bf35bb0f3d3022c1ca90db5b7243bedadeccddc");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_generator_overview_generated", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_generator_overview_generated", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_generator_overview_generated", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonGeneratorOverviewGenerationFailedProperties {
  generatorInputMethod: GeneratorInputMethodValueType;
}
/**
 * lesson_generator_overview_generation_failed: Triggers when we can't generate the overview for a lesson, based on the outline
 * 
 * @param properties the properties associatied with this event
 * @param properties.generatorInputMethod: Kind of input a user can use to generate lessons. A user has the possibility to upload images (photos of a book) or provide a text themselves
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/UK4v1xh_ql}
 */
export function lessonGeneratorOverviewGenerationFailed(properties: LessonGeneratorOverviewGenerationFailedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "fsFXfrOPBe", name: "generator_input_method", value: properties.generatorInputMethod});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "UK4v1xh_ql", "f787acf7a82ebe37fb009806d51e467b0af73e348304d14b6597f2e641bb6674", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_generator_overview_generation_failed", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("UK4v1xh_ql", "lesson_generator_overview_generation_failed", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_generator_overview_generation_failed", eventProperties, "UK4v1xh_ql", "f787acf7a82ebe37fb009806d51e467b0af73e348304d14b6597f2e641bb6674");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_generator_overview_generation_failed", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_generator_overview_generation_failed", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_generator_overview_generation_failed", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonGeneratorLessonCreatedProperties {
  generatorInputMethod: GeneratorInputMethodValueType;
  pinCount: number;
}
/**
 * lesson_generator_lesson_created: When the user actually creates a lesson based on the lesson overview generated by the lesson generator
 * 
 * @param properties the properties associatied with this event
 * @param properties.generatorInputMethod: Kind of input a user can use to generate lessons. A user has the possibility to upload images (photos of a book) or provide a text themselves
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/sDy5arApHZ}
 */
export function lessonGeneratorLessonCreated(properties: LessonGeneratorLessonCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "fsFXfrOPBe", name: "generator_input_method", value: properties.generatorInputMethod});
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "sDy5arApHZ", "6f14adde1fc03e50aae154975955dcf1f76c86c63fc82670ccd6b41d497276a8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_generator_lesson_created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("sDy5arApHZ", "lesson_generator_lesson_created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_generator_lesson_created", eventProperties, "sDy5arApHZ", "6f14adde1fc03e50aae154975955dcf1f76c86c63fc82670ccd6b41d497276a8");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_generator_lesson_created", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_generator_lesson_created", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_generator_lesson_created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ReferralModalOpenedProperties {
  referralToken: string;
}
/**
 * referral_modal_opened: The point at which the user opens the Teacher Referral Modal (Invite a Colleague)
 * 
 * When to trigger this event:
 * 1. Modal gets opened by clicking on the invite a colleague button (will change once we have a separate page).
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ToIg_HxKg7/trigger/R_Eo_WO5p
 * 2. When modal is opened, we trigger the event.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ToIg_HxKg7/trigger/4S4RFxB1r
 * 
 * @param properties the properties associatied with this event
 * @param properties.referralToken: Token unique to each user, used in Teacher Referral events e.g. generate referral Link, Referred registration.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ToIg_HxKg7}
 */
export function referralModalOpened(properties: ReferralModalOpenedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "FP0uPAxB7", name: "referral_token", value: properties.referralToken});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ToIg_HxKg7", "f1813241d233a7f333b518c04c5e242103331e224a8848b648c1a2604b22251d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("referral_modal_opened", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ToIg_HxKg7", "referral_modal_opened", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("referral_modal_opened", eventProperties, "ToIg_HxKg7", "f1813241d233a7f333b518c04c5e242103331e224a8848b648c1a2604b22251d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("referral_modal_opened", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("referral_modal_opened", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("referral_modal_opened", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface ReferralLinkCopiedProperties {
  referralToken: string;
}
/**
 * referral_link_copied: The point at which the user copied the link for referral
 * 
 * When to trigger this event:
 * 1. When user copies the link in the referral modal
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/vCOynVBO5a/trigger/u-Bk2rTyY
 * 2. When user copies the link on the referral page
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/vCOynVBO5a/trigger/vhkl7rcQq
 * 
 * @param properties the properties associatied with this event
 * @param properties.referralToken: Token unique to each user, used in Teacher Referral events e.g. generate referral Link, Referred registration.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/vCOynVBO5a}
 */
export function referralLinkCopied(properties: ReferralLinkCopiedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "FP0uPAxB7", name: "referral_token", value: properties.referralToken});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "vCOynVBO5a", "9798af38ebfb25844c3861db520092418c17202a8c805804b760b2de8e143987", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("referral_link_copied", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("vCOynVBO5a", "referral_link_copied", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("referral_link_copied", eventProperties, "vCOynVBO5a", "9798af38ebfb25844c3861db520092418c17202a8c805804b760b2de8e143987");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("referral_link_copied", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("referral_link_copied", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("referral_link_copied", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * ai_start: The beginning of the ai flow. A button at the top of the editor.
 * 
 * When to trigger this event:
 * 1. A user clicks on the Maia button to start the flow
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/_xEfRtJvZu/trigger/keSUVeTpr
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/_xEfRtJvZu}
 */
export function aiStart() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "_xEfRtJvZu", "214e837bf3eeb2183c6c1654ecd44cb7bb08f139149a8a2eddc34dada2dd1d58", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_start", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("_xEfRtJvZu", "ai_start", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_start", eventProperties, "_xEfRtJvZu", "214e837bf3eeb2183c6c1654ecd44cb7bb08f139149a8a2eddc34dada2dd1d58");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_start", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_start", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_start", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiOpenedProperties {
  aiInputMethod: AiInputMethodValueType;
}
/**
 * ai_opened: User lands on the first ai page, where they can input their prompt.
 * 
 * When to trigger this event:
 * 1. Fires when user gets to the step where they can enter their first prompt.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YfkDacvvhi/trigger/kWCTUUzqo
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiInputMethod: The input method for the ai prompt
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/YfkDacvvhi}
 */
export function aiOpened(properties: AiOpenedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "T0rz2kdcU", name: "ai_input_method", value: properties.aiInputMethod});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "YfkDacvvhi", "cfd35b46493f804a37363324aded219bfc3c3e0b98b570758fa16faa18b7805e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_opened", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("YfkDacvvhi", "ai_opened", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_opened", eventProperties, "YfkDacvvhi", "cfd35b46493f804a37363324aded219bfc3c3e0b98b570758fa16faa18b7805e");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_opened", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_opened", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_opened", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiLessonPreviewProperties {
  languageOutput: string;
  aiInputMethod: AiInputMethodValueType;
  aiInputLength: number;
  learningPhases: boolean;
  activateKnowledge: boolean;
  exitTicket: boolean;
  totalPinCount: number;
}
/**
 * ai_lesson_preview: Page is loaded where users can preview the slides of their lesson and select which they want to use.
 * 
 * @param properties the properties associatied with this event
 * @param properties.languageOutput: The output language of the ai generated slides
 * @param properties.aiInputMethod: The input method for the ai prompt
 * @param properties.aiInputLength: The length of the prompt sent to open ai
 * @param properties.learningPhases: Whether learning phases is set for the ai generated lesson True = it is set on.
 * @param properties.activateKnowledge: Whether activate knowledge is set for the ai generated lesson True = it is set on.
 * @param properties.exitTicket: Whether exit ticket is set for the ai generated lesson True = it is set on.
 * @param properties.totalPinCount: The total amount of slides in a lesson.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/-d-1DJJN6g}
 */
export function aiLessonPreview(properties: AiLessonPreviewProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
eventPropertiesArray.push({id: "T0rz2kdcU", name: "ai_input_method", value: properties.aiInputMethod});
eventPropertiesArray.push({id: "bSKEZjONV", name: "ai_input_length", value: properties.aiInputLength});
eventPropertiesArray.push({id: "Lm0guxAZf", name: "learning_phases", value: properties.learningPhases});
eventPropertiesArray.push({id: "ZnqnTP1zz", name: "activate_knowledge", value: properties.activateKnowledge});
eventPropertiesArray.push({id: "MVIPKncyD", name: "exit_ticket", value: properties.exitTicket});
eventPropertiesArray.push({id: "3x5vYiHN9W", name: "total_pin_count", value: properties.totalPinCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "-d-1DJJN6g", "47bff79c316af083e4201ee1b26b8b67ff89f1744eab3a1b904559832dd0d2a0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_lesson_preview", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("-d-1DJJN6g", "ai_lesson_preview", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_lesson_preview", eventProperties, "-d-1DJJN6g", "47bff79c316af083e4201ee1b26b8b67ff89f1744eab3a1b904559832dd0d2a0");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_lesson_preview", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_lesson_preview", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_lesson_preview", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiLessonStructureProperties {
  aiInputMethod: AiInputMethodValueType;
  aiInputLength: number;
  languageOutput: string;
}
/**
 * ai_lesson_structure: a step in between the first prompt input and the preview of the generated slides. This is there only for the long text prompt and the image prompt.
 * 
 * When to trigger this event:
 * 1. Fires when user reaches the page where we show the lesson structure.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/OYTZmhoN8T/trigger/tIT0BmjBN
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiInputMethod: The input method for the ai prompt
 * @param properties.aiInputLength: The length of the prompt sent to open ai
 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/OYTZmhoN8T}
 */
export function aiLessonStructure(properties: AiLessonStructureProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "T0rz2kdcU", name: "ai_input_method", value: properties.aiInputMethod});
eventPropertiesArray.push({id: "bSKEZjONV", name: "ai_input_length", value: properties.aiInputLength});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "OYTZmhoN8T", "874b05a26f6165d88bd9fd96be8825fb36692ceb8991b2f1a607e6f58671e2ae", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_lesson_structure", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("OYTZmhoN8T", "ai_lesson_structure", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_lesson_structure", eventProperties, "OYTZmhoN8T", "874b05a26f6165d88bd9fd96be8825fb36692ceb8991b2f1a607e6f58671e2ae");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_lesson_structure", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_lesson_structure", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_lesson_structure", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiErrorProperties {
  errorDescription: string;
  aiInputMethod: AiInputMethodValueType;
  aiInputLength: number;
}
/**
 * ai_error: Fires when an error occurs in the ai flow
 * 
 * @param properties the properties associatied with this event
 * @param properties.errorDescription: This is an open string type that we can use to describe the error that occured.
 * @param properties.aiInputMethod: The input method for the ai prompt
 * @param properties.aiInputLength: The length of the prompt sent to open ai
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/7o5hyBjYTf}
 */
export function aiError(properties: AiErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "bLIJ_EhVD", name: "error_description", value: properties.errorDescription});
eventPropertiesArray.push({id: "T0rz2kdcU", name: "ai_input_method", value: properties.aiInputMethod});
eventPropertiesArray.push({id: "bSKEZjONV", name: "ai_input_length", value: properties.aiInputLength});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "7o5hyBjYTf", "76360748fc1eb54d517dfc00b9806be5781b42c46dd3d0b40ab2793e876ad2a4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_error", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("7o5hyBjYTf", "ai_error", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_error", eventProperties, "7o5hyBjYTf", "76360748fc1eb54d517dfc00b9806be5781b42c46dd3d0b40ab2793e876ad2a4");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_error", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_error", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_error", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiLessonCreatedProperties {
  lessonId: string;
  pinCount: number;
  learningPhases: boolean;
  exitTicket: boolean;
  activateKnowledge: boolean;
}
/**
 * ai_lesson_created: Final action for the ai lesson generator, when the user creates the lesson.
 * 
 * When to trigger this event:
 * 1. User creates the lesson
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/1_OjQODdB/trigger/g7rS-bcVU
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * @param properties.learningPhases: Whether learning phases is set for the ai generated lesson True = it is set on.
 * @param properties.exitTicket: Whether exit ticket is set for the ai generated lesson True = it is set on.
 * @param properties.activateKnowledge: Whether activate knowledge is set for the ai generated lesson True = it is set on.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/1_OjQODdB}
 */
export function aiLessonCreated(properties: AiLessonCreatedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
eventPropertiesArray.push({id: "Lm0guxAZf", name: "learning_phases", value: properties.learningPhases});
eventPropertiesArray.push({id: "MVIPKncyD", name: "exit_ticket", value: properties.exitTicket});
eventPropertiesArray.push({id: "ZnqnTP1zz", name: "activate_knowledge", value: properties.activateKnowledge});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "1_OjQODdB", "7d9d44b40eda0585f0d01d8bb24a6d1a778f712fbc4f78acf7b0f4e0811f844b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_lesson_created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("1_OjQODdB", "ai_lesson_created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_lesson_created", eventProperties, "1_OjQODdB", "7d9d44b40eda0585f0d01d8bb24a6d1a778f712fbc4f78acf7b0f4e0811f844b");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_lesson_created", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_lesson_created", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_lesson_created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * lesson_click_powerpoint: User clicks the create with powerpoint button, but doesn't start the upload yet.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/NraFFiWoGd}
 */
export function lessonClickPowerpoint() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "NraFFiWoGd", "aa8c7715296d0bf3e050e383f572c7efe5a6a2b11990121c7d46a091d9a2cd1f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_click_powerpoint", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("NraFFiWoGd", "lesson_click_powerpoint", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_click_powerpoint", eventProperties, "NraFFiWoGd", "aa8c7715296d0bf3e050e383f572c7efe5a6a2b11990121c7d46a091d9a2cd1f");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_click_powerpoint", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_click_powerpoint", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_click_powerpoint", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonPowerpointConvertedProperties {
  lessonId: string;
  pinCount: number;
  fileSizeInBytes: string;
}
/**
 * lesson_powerpoint_converted: User has finished converting a powerpoint lesson into a lessonup lesson
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.pinCount: The pin_count. What this mean could differ the depending on the context of the event it is sent with.
 * @param properties.fileSizeInBytes: The file size in bytes. This is to keep track of file size for powerpoint uploads and can later be added to generic uploads or pdf exports as well.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/5nZj5i_G5_}
 */
export function lessonPowerpointConverted(properties: LessonPowerpointConvertedProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "usZeg9Ldj", name: "pin_count", value: properties.pinCount});
eventPropertiesArray.push({id: "E9uvBDz50", name: "file_size_in_bytes", value: properties.fileSizeInBytes});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "5nZj5i_G5_", "7f13b9f31e8a9d6d323d3729dbd198d838fca1921f913040046c1e2a69b51685", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_powerpoint_converted", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("5nZj5i_G5_", "lesson_powerpoint_converted", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_powerpoint_converted", eventProperties, "5nZj5i_G5_", "7f13b9f31e8a9d6d323d3729dbd198d838fca1921f913040046c1e2a69b51685");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_powerpoint_converted", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_powerpoint_converted", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_powerpoint_converted", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonPowerpointStartConversionProperties {
  fileSizeInBytes: string;
}
/**
 * lesson_powerpoint_start_conversion: User starts the slide deck conversion
 * 
 * When to trigger this event:
 * 1. The user has selected a PowerPoint file from which they'd like to start a conversion and they have clicked the "create lesson" button.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/xigNdMfHz/trigger/-PFZ6tdOg
 * 
 * @param properties the properties associatied with this event
 * @param properties.fileSizeInBytes: The file size in bytes. This is to keep track of file size for powerpoint uploads and can later be added to generic uploads or pdf exports as well.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/xigNdMfHz}
 */
export function lessonPowerpointStartConversion(properties: LessonPowerpointStartConversionProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "E9uvBDz50", name: "file_size_in_bytes", value: properties.fileSizeInBytes});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "xigNdMfHz", "a3578288b8a720dd633978953e52f3d5cd39c15a843ea64373183bed294e2e3d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_powerpoint_start_conversion", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("xigNdMfHz", "lesson_powerpoint_start_conversion", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_powerpoint_start_conversion", eventProperties, "xigNdMfHz", "a3578288b8a720dd633978953e52f3d5cd39c15a843ea64373183bed294e2e3d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_powerpoint_start_conversion", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_powerpoint_start_conversion", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_powerpoint_start_conversion", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * registration_verification_start: Someone started the email verification process as part of their registration
 * 
 * When to trigger this event:
 * 1. Someone filled in an email address and pressed the button. The backend responded that it received the request to send a verification email.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/uhtIgH9zy8/trigger/qTKMOEXr-
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/uhtIgH9zy8}
 */
export function registrationVerificationStart() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "uhtIgH9zy8", "4262a25fbcb985c88e99704b7a2f3a8c71b751434eecaac996c04dbf2b462363", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("registration_verification_start", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("uhtIgH9zy8", "registration_verification_start", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_verification_start", eventProperties, "uhtIgH9zy8", "4262a25fbcb985c88e99704b7a2f3a8c71b751434eecaac996c04dbf2b462363");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("registration_verification_start", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("registration_verification_start", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("registration_verification_start", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * registration_verification_successful: A valid email verification token was used to continue the registration process
 * 
 * When to trigger this event:
 * 1. The password page was opened, meaning the email verification was successful
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/3M0Gukzxwq/trigger/Og2ZoEr04
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/3M0Gukzxwq}
 */
export function registrationVerificationSuccessful() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3M0Gukzxwq", "fe833ccd6fdacca3792db0cfd0d02ddb4fe2375a8bc9f49bce46115aa2e89bc3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("registration_verification_successful", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3M0Gukzxwq", "registration_verification_successful", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_verification_successful", eventProperties, "3M0Gukzxwq", "fe833ccd6fdacca3792db0cfd0d02ddb4fe2375a8bc9f49bce46115aa2e89bc3");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("registration_verification_successful", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("registration_verification_successful", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("registration_verification_successful", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * registration_verification_link_expired: Someone has opened a verification link that was either already used, or they waited too long to use it.
 * 
 * When to trigger this event:
 * 1. Someone has opened a verification link that was either already used, or they waited too long to use it. The event is triggered when the page that shows this message opens.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/meDfjM_4b5/trigger/XYTg_xp2t
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/meDfjM_4b5}
 */
export function registrationVerificationLinkExpired() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "meDfjM_4b5", "f7056d3d9c76b693821051dd84b7a188b4a244f0be59d798340277f1b16200e6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("registration_verification_link_expired", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("meDfjM_4b5", "registration_verification_link_expired", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_verification_link_expired", eventProperties, "meDfjM_4b5", "f7056d3d9c76b693821051dd84b7a188b4a244f0be59d798340277f1b16200e6");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("registration_verification_link_expired", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("registration_verification_link_expired", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("registration_verification_link_expired", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * registration_password_created: A valid password was filled in and the user has successfully been created in the database.
 * 
 * When to trigger this event:
 * 1. A valid password was filled in and the user has successfully been created in the database.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ZGVaUtuAk5/trigger/njGllpWL9
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ZGVaUtuAk5}
 */
export function registrationPasswordCreated() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ZGVaUtuAk5", "3b0a66233f62295a2b50ef477237301c3d6d695bbfed1d4dff3e9598c5b48d4d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("registration_password_created", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ZGVaUtuAk5", "registration_password_created", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_password_created", eventProperties, "ZGVaUtuAk5", "3b0a66233f62295a2b50ef477237301c3d6d695bbfed1d4dff3e9598c5b48d4d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("registration_password_created", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("registration_password_created", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("registration_password_created", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface RegistrationErrorProperties {
  errorDescription: string;
}
/**
 * registration_error: Errors during registration process
 * 
 * When to trigger this event:
 * 1. Something goes wrong after submitting an email address for verification.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/kPDWCF7FNb/trigger/YUE8P4i0x
 * 2. An error occurred when trying to create and account with the provided password and verified email.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/kPDWCF7FNb/trigger/n2YVN6rnl
 * 
 * @param properties the properties associatied with this event
 * @param properties.errorDescription: This is an open string type that we can use to describe the error that occured.
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/kPDWCF7FNb}
 */
export function registrationError(properties: RegistrationErrorProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "bLIJ_EhVD", name: "error_description", value: properties.errorDescription});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "kPDWCF7FNb", "a4d43ff03d52dcb72ddb4f45cefb79511947875d04d2fa778f59c4fa87e30fe4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("registration_error", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("kPDWCF7FNb", "registration_error", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("registration_error", eventProperties, "kPDWCF7FNb", "a4d43ff03d52dcb72ddb4f45cefb79511947875d04d2fa778f59c4fa87e30fe4");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("registration_error", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("registration_error", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("registration_error", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface TeacherLoginProperties {
  loginMethod: LoginMethodValueType;
}
/**
 * teacher_login: The teacher manually logs into LessonUp
 * 
 * When to trigger this event:
 * 1. Triggered when manually logging into LessonUp
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ifzaUc8iI01/trigger/UP3BGilZuaN
 * 2. User can also login from som, canvas, itslearning or other future integrations. That will trigger from their respective platforms.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ifzaUc8iI01/trigger/RTaz3XURSG6
 * 
 * @param properties the properties associatied with this event
 * @param properties.loginMethod: The method used to manually login to lessonup
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ifzaUc8iI01}
 */
export function teacherLogin(properties: TeacherLoginProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "cfa3XCWzO", name: "login_method", value: properties.loginMethod});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ifzaUc8iI01", "0a86fae4e1a2780dbfc42161a4b69601e212982b29852830ff8458a293935cfe", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("teacher_login", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ifzaUc8iI01", "teacher_login", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("teacher_login", eventProperties, "ifzaUc8iI01", "0a86fae4e1a2780dbfc42161a4b69601e212982b29852830ff8458a293935cfe");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("teacher_login", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("teacher_login", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("teacher_login", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PinComponentCreateProperties {
  pinComponentType: PinComponentTypeValueType;
  pinComponentCreationMethod: PinComponentCreationMethodValueType;
  pinComponentCount: number;
}
/**
 * pin_component_create: When a user creates a pin component in the editor
 * 
 * @param properties the properties associatied with this event
 * @param properties.pinComponentType: The pin component type. Pin components are all types of components that can be added to a slide. e.g. text, images, etc.

We have property value constraints, so if we introduce new components in the future we need to make sure they are added to the allowed values. At the time of implementation, the allowed values contain more components than we currently support in the new editor.
 * @param properties.pinComponentCreationMethod: The method used to create the pin_component. Users can add pin components in more than one way. With this we can track which methods are used most frequently. For instance the item search, copy/pasting or other methods.
 * @param properties.pinComponentCount: The amount of pin components added
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/0wbeWedLuRc}
 */
export function pinComponentCreate(properties: PinComponentCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "9oahjq9hn", name: "pin_component_type", value: properties.pinComponentType});
eventPropertiesArray.push({id: "uLHmAgNm1", name: "pin_component_creation_method", value: properties.pinComponentCreationMethod});
eventPropertiesArray.push({id: "98Fz1d0pLrhmlfwOnBiuB", name: "pin_component_count", value: properties.pinComponentCount});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "0wbeWedLuRc", "251d1d14ba825941cd2ec8ff86e582ee5e2f6afa56710c8c4c0794c0dee2bae1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("pin_component_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("0wbeWedLuRc", "pin_component_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("pin_component_create", eventProperties, "0wbeWedLuRc", "251d1d14ba825941cd2ec8ff86e582ee5e2f6afa56710c8c4c0794c0dee2bae1");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("pin_component_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("pin_component_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("pin_component_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface LessonPresenterModeProperties {
  lessonId: string;
  assignmentId: string;
  context: string;
}
/**
 * lesson_presenter_mode: The teacher starts the presenter mode for teaching (aka teacher view, docentweergave). 
 * 
 * When to trigger this event:
 * 1. The teacher can start teaching a lesson and open the teacher view simultaniously.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/jyZfYnXmy0Sp7aRy-L106/trigger/OJkIIg5Ab4p0uiEK636kN
 * 2. If already teaching in the teacher player, the teacher can open the presenter mode from the settings menu.
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/jyZfYnXmy0Sp7aRy-L106/trigger/KXn09_JyswMZzLsjYRakS
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.assignmentId: An assignment id is every unique instance of a lesson being taught, if the same lesson is taught twice this will result in 2 different assignment id's
 * @param properties.context: This is a generic property that can be used to give some extra context to the event. Most commonly, I expect it will be used to clarify how I certain event is fired (e.g. edit made in the side-bar or in the floating action menu)
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/jyZfYnXmy0Sp7aRy-L106}
 */
export function lessonPresenterMode(properties: LessonPresenterModeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "EB0CImeWls", name: "assignment_id", value: properties.assignmentId});
eventPropertiesArray.push({id: "VpRJVknRCxnpVPQGupVk5", name: "context", value: properties.context});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "jyZfYnXmy0Sp7aRy-L106", "6a840075b5515e2e622c35683767e7d7dc59e106c54fb1d58b29b9d076dfe862", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("lesson_presenter_mode", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("jyZfYnXmy0Sp7aRy-L106", "lesson_presenter_mode", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("lesson_presenter_mode", eventProperties, "jyZfYnXmy0Sp7aRy-L106", "6a840075b5515e2e622c35683767e7d7dc59e106c54fb1d58b29b9d076dfe862");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("lesson_presenter_mode", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("lesson_presenter_mode", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("lesson_presenter_mode", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

/**
 * student_navigate_to_app: An action that redirects a visitor to the lessonup.app student application.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/u304Zjajv3usW20K-70g8/trigger/6L6iswmX7gyMEIYvELqjE
 * 2. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/u304Zjajv3usW20K-70g8/trigger/M-MiB0mXHB5cuIAy-pJkf
 * 3. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/u304Zjajv3usW20K-70g8/trigger/cPqMdMj3MHWHYpM0T8lJf
 * 4. 
 * View in Avo: https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/u304Zjajv3usW20K-70g8/trigger/qrYVC9yXuG3T94DJ7YdaO
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/u304Zjajv3usW20K-70g8}
 */
export function studentNavigateToApp() {
// @ts-ignore
let eventPropertiesArray: array = [];
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "u304Zjajv3usW20K-70g8", "65fead38d8c81d6429e19c63425ad2089780cb81d604163525c12994b5fb310a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("student_navigate_to_app", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("u304Zjajv3usW20K-70g8", "student_navigate_to_app", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("student_navigate_to_app", eventProperties, "u304Zjajv3usW20K-70g8", "65fead38d8c81d6429e19c63425ad2089780cb81d604163525c12994b5fb310a");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("student_navigate_to_app", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("student_navigate_to_app", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("student_navigate_to_app", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SpinnerSpinProperties {
  lessonId: string;
  assignmentId: string;
  context: string;
}
/**
 * spinner_spin: The user spins the spinner. Context property defines whether user spins with or without 
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.assignmentId: An assignment id is every unique instance of a lesson being taught, if the same lesson is taught twice this will result in 2 different assignment id's
 * @param properties.context: This is a generic property that can be used to give some extra context to the event. Most commonly, I expect it will be used to clarify how I certain event is fired (e.g. edit made in the side-bar or in the floating action menu)
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/Sm26IYstJ2_WuSE5OYt3i}
 */
export function spinnerSpin(properties: SpinnerSpinProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "EB0CImeWls", name: "assignment_id", value: properties.assignmentId});
eventPropertiesArray.push({id: "VpRJVknRCxnpVPQGupVk5", name: "context", value: properties.context});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "Sm26IYstJ2_WuSE5OYt3i", "0108b776f52896d879ee54d7244a070dbd638f7422f31503311aef566924b562", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("spinner_spin", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("Sm26IYstJ2_WuSE5OYt3i", "spinner_spin", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("spinner_spin", eventProperties, "Sm26IYstJ2_WuSE5OYt3i", "0108b776f52896d879ee54d7244a070dbd638f7422f31503311aef566924b562");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("spinner_spin", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("spinner_spin", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("spinner_spin", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface PlayerComponentCreateProperties {
  playerComponentType: PlayerComponentTypeValueType;
  lessonId: string;
  assignmentId: string;
}
/**
 * player_component_create: Components created in the teacher player, such as spinners, timers, etc. Created instantly whilst teaching.
 * 
 * @param properties the properties associatied with this event
 * @param properties.playerComponentType: When a 
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.assignmentId: An assignment id is every unique instance of a lesson being taught, if the same lesson is taught twice this will result in 2 different assignment id's
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/3QbpAuio1O445JluPQCya}
 */
export function playerComponentCreate(properties: PlayerComponentCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "nfzorsRj8pQfbwyrY-6u5", name: "player_component_type", value: properties.playerComponentType});
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "EB0CImeWls", name: "assignment_id", value: properties.assignmentId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3QbpAuio1O445JluPQCya", "3997ff9c5edcab449114e066c7c4a7bb48847c1ad2560bfd72d4933b130bcfd5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("player_component_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3QbpAuio1O445JluPQCya", "player_component_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("player_component_create", eventProperties, "3QbpAuio1O445JluPQCya", "3997ff9c5edcab449114e066c7c4a7bb48847c1ad2560bfd72d4933b130bcfd5");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("player_component_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("player_component_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("player_component_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface SpinnerResetProperties {
  lessonId: string;
  assignmentId: string;
}
/**
 * spinner_reset: User resets the spinner in the teacher player
 * 
 * @param properties the properties associatied with this event
 * @param properties.lessonId: The unique identification of the lesson.
 * @param properties.assignmentId: An assignment id is every unique instance of a lesson being taught, if the same lesson is taught twice this will result in 2 different assignment id's
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/8bde640d-1a8a-48ad-a4ea-f035ac5b4d88}
 */
export function spinnerReset(properties: SpinnerResetProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "AzEghFPzw1", name: "lesson_id", value: properties.lessonId});
eventPropertiesArray.push({id: "EB0CImeWls", name: "assignment_id", value: properties.assignmentId});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "8bde640d-1a8a-48ad-a4ea-f035ac5b4d88", "973125e46dc97fa36a38358a500a7f1f54cd1d87cf48c3915557798c5f4e4c2c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("spinner_reset", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("8bde640d-1a8a-48ad-a4ea-f035ac5b4d88", "spinner_reset", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("spinner_reset", eventProperties, "8bde640d-1a8a-48ad-a4ea-f035ac5b4d88", "973125e46dc97fa36a38358a500a7f1f54cd1d87cf48c3915557798c5f4e4c2c");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("spinner_reset", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("spinner_reset", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("spinner_reset", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsTextSummarizeProperties {
  summaryLength: string;
  educationalLevel: string;
  promptLength: number;
  languageOutput: string;
}
/**
 * ai_tools_text_summarize: User successfully generated summary of the text input
 * 
 * @param properties the properties associatied with this event
 * @param properties.summaryLength: The length that is used to generate the summary.
 * @param properties.educationalLevel: The educational level the generated output needs to adhere to.

 * @param properties.promptLength: The number of characters of the text prompt
 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/216bdba0-9b0d-489a-b227-af693651820c}
 */
export function aiToolsTextSummarize(properties: AiToolsTextSummarizeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "7f7oeAljjIPlTQLohGWQE", name: "summary_length", value: properties.summaryLength});
eventPropertiesArray.push({id: "Rdt6wSGJ3BclL7pojoeoA", name: "educational_level", value: properties.educationalLevel});
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "216bdba0-9b0d-489a-b227-af693651820c", "a8b0b029731b5f3f3941732300e3099c10d10967199dd5d106a253d2b8dc7aa7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_text_summarize", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("216bdba0-9b0d-489a-b227-af693651820c", "ai_tools_text_summarize", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_text_summarize", eventProperties, "216bdba0-9b0d-489a-b227-af693651820c", "a8b0b029731b5f3f3941732300e3099c10d10967199dd5d106a253d2b8dc7aa7");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_text_summarize", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_text_summarize", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_text_summarize", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsWebsiteSummarizeProperties {
  summaryLength: string;
  educationalLevel: string;
  languageOutput: string;
}
/**
 * ai_tools_website_summarize: User successfully generated summary of the webpage.
 * 
 * @param properties the properties associatied with this event
 * @param properties.summaryLength: The length that is used to generate the summary.
 * @param properties.educationalLevel: The educational level the generated output needs to adhere to.

 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/05d03dbe-9a6f-4dc2-b940-0d407949b7f4}
 */
export function aiToolsWebsiteSummarize(properties: AiToolsWebsiteSummarizeProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "7f7oeAljjIPlTQLohGWQE", name: "summary_length", value: properties.summaryLength});
eventPropertiesArray.push({id: "Rdt6wSGJ3BclL7pojoeoA", name: "educational_level", value: properties.educationalLevel});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "05d03dbe-9a6f-4dc2-b940-0d407949b7f4", "68eeb74101575cc4f955384da49f790d91c76562f0b753e66b12a68115dbc3fa", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_website_summarize", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("05d03dbe-9a6f-4dc2-b940-0d407949b7f4", "ai_tools_website_summarize", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_website_summarize", eventProperties, "05d03dbe-9a6f-4dc2-b940-0d407949b7f4", "68eeb74101575cc4f955384da49f790d91c76562f0b753e66b12a68115dbc3fa");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_website_summarize", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_website_summarize", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_website_summarize", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsTextTranslateProperties {
  languageOutput: string;
  promptLength: number;
}
/**
 * ai_tools_text_translate: User successfully translated text.
 * 
 * @param properties the properties associatied with this event
 * @param properties.languageOutput: The output language of the ai generated slides
 * @param properties.promptLength: The number of characters of the text prompt
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/d28a07d3-1414-43d4-bb29-dbf963404909}
 */
export function aiToolsTextTranslate(properties: AiToolsTextTranslateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "d28a07d3-1414-43d4-bb29-dbf963404909", "9b4ee8041321c5826ee2f8ed95a27a0841c58469bd4d256fe29163b9aefcefaf", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_text_translate", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("d28a07d3-1414-43d4-bb29-dbf963404909", "ai_tools_text_translate", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_text_translate", eventProperties, "d28a07d3-1414-43d4-bb29-dbf963404909", "9b4ee8041321c5826ee2f8ed95a27a0841c58469bd4d256fe29163b9aefcefaf");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_text_translate", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_text_translate", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_text_translate", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsTextRewriteProperties {
  toneOfVoice: string;
  educationalLevel: string;
  promptLength: number;
  languageOutput: string;
}
/**
 * ai_tools_text_rewrite: User successfully rewrote text.
 * 
 * @param properties the properties associatied with this event
 * @param properties.toneOfVoice: The style which the generated output needs to adhere to.
 * @param properties.educationalLevel: The educational level the generated output needs to adhere to.

 * @param properties.promptLength: The number of characters of the text prompt
 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/c3d6d0d8-cfe4-4691-b3f8-8495940b62cf}
 */
export function aiToolsTextRewrite(properties: AiToolsTextRewriteProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "BJ0LtjgwXEqsqNDjbXSdE", name: "tone_of_voice", value: properties.toneOfVoice});
eventPropertiesArray.push({id: "Rdt6wSGJ3BclL7pojoeoA", name: "educational_level", value: properties.educationalLevel});
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "c3d6d0d8-cfe4-4691-b3f8-8495940b62cf", "d709ca390828b1d222fb4b2e032819a762444b4e18a38b0cdb23ca11f028d52d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_text_rewrite", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("c3d6d0d8-cfe4-4691-b3f8-8495940b62cf", "ai_tools_text_rewrite", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_text_rewrite", eventProperties, "c3d6d0d8-cfe4-4691-b3f8-8495940b62cf", "d709ca390828b1d222fb4b2e032819a762444b4e18a38b0cdb23ca11f028d52d");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_text_rewrite", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_text_rewrite", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_text_rewrite", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsRubricCreateProperties {
  educationalLevel: string;
  rubricType: string;
  scoringScale: string;
  performanceLevels: number;
  promptLength: number;
  languageOutput: string;
}
/**
 * ai_tools_rubric_create: User successfully generated a rubric.
 * 
 * @param properties the properties associatied with this event
 * @param properties.educationalLevel: The educational level the generated output needs to adhere to.

 * @param properties.rubricType: The type of rubric that is generated (Analytical-detailed criteria or Holistic-overall performance.
 * @param properties.scoringScale: The type of scoring that is used for the rubric (numeric or descriptive).
 * @param properties.performanceLevels: The number of performance levels that are generated.
 * @param properties.promptLength: The number of characters of the text prompt
 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/3a685520-3d25-4402-bc1d-651012e9f7a1}
 */
export function aiToolsRubricCreate(properties: AiToolsRubricCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Rdt6wSGJ3BclL7pojoeoA", name: "educational_level", value: properties.educationalLevel});
eventPropertiesArray.push({id: "duyN5WHmpkuBVDg0KFOCA", name: "rubric_type", value: properties.rubricType});
eventPropertiesArray.push({id: "c7BH2fTGQ1eAH7fkDWPyY", name: "scoring_scale", value: properties.scoringScale});
eventPropertiesArray.push({id: "lHmkS-riEwLF4qr6xWFma", name: "performance_levels", value: properties.performanceLevels});
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "3a685520-3d25-4402-bc1d-651012e9f7a1", "86712c8ef5dd9c04e3f8c3b5ba7983a43e89f74bd337b99e37e2348220739e67", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_rubric_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("3a685520-3d25-4402-bc1d-651012e9f7a1", "ai_tools_rubric_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_rubric_create", eventProperties, "3a685520-3d25-4402-bc1d-651012e9f7a1", "86712c8ef5dd9c04e3f8c3b5ba7983a43e89f74bd337b99e37e2348220739e67");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_rubric_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_rubric_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_rubric_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsGlossaryCreateProperties {
  educationalLevel: string;
  numberOfResults: number;
  glossaryFormat: string;
  lessonAsInput: boolean;
  promptLength: number;
  languageOutput: string;
}
/**
 * ai_tools_glossary_create: User successfully generated a glossary.
 * 
 * @param properties the properties associatied with this event
 * @param properties.educationalLevel: The educational level the generated output needs to adhere to.

 * @param properties.numberOfResults: The number of results that is chosen to generate.
 * @param properties.glossaryFormat: The format of the generated glossary.
 * @param properties.lessonAsInput: Indicate whether the input that is used is based on a LessonUp lesson. True = yes.
 * @param properties.promptLength: The number of characters of the text prompt
 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/070dcc26-7c99-4316-a401-f11d7b370dda}
 */
export function aiToolsGlossaryCreate(properties: AiToolsGlossaryCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Rdt6wSGJ3BclL7pojoeoA", name: "educational_level", value: properties.educationalLevel});
eventPropertiesArray.push({id: "aVwM59Bqh6pNUMeMeIu0l", name: "number_of_results", value: properties.numberOfResults});
eventPropertiesArray.push({id: "OdesrP3cPLCU0r-JY8P3v", name: "glossary_format", value: properties.glossaryFormat});
eventPropertiesArray.push({id: "jaXE5ABxGERPcMgoO_4Hd", name: "lesson_as_input", value: properties.lessonAsInput});
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "070dcc26-7c99-4316-a401-f11d7b370dda", "dc1a50cf50e6de0587d4b954da12b4c2dcd10c0d04713f56deeb91114361bb85", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_glossary_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("070dcc26-7c99-4316-a401-f11d7b370dda", "ai_tools_glossary_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_glossary_create", eventProperties, "070dcc26-7c99-4316-a401-f11d7b370dda", "dc1a50cf50e6de0587d4b954da12b4c2dcd10c0d04713f56deeb91114361bb85");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_glossary_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_glossary_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_glossary_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsDebateTopicsCreateProperties {
  educationalLevel: string;
  statementCreated: boolean;
  numberOfResults: number;
  promptLength: number;
  languageOutput: string;
}
/**
 * ai_tools_debate_topics_create: User successfully generated debate topics.
 * 
 * @param properties the properties associatied with this event
 * @param properties.educationalLevel: The educational level the generated output needs to adhere to.

 * @param properties.statementCreated: The option to choose whether a statement is created yes or no. True = yes.
 * @param properties.numberOfResults: The number of results that is chosen to generate.
 * @param properties.promptLength: The number of characters of the text prompt
 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/a25cb249-d421-4a79-ad74-93925ee63ddd}
 */
export function aiToolsDebateTopicsCreate(properties: AiToolsDebateTopicsCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Rdt6wSGJ3BclL7pojoeoA", name: "educational_level", value: properties.educationalLevel});
eventPropertiesArray.push({id: "URVGphzDcf23VzhX5BhiQ", name: "statement_created", value: properties.statementCreated});
eventPropertiesArray.push({id: "aVwM59Bqh6pNUMeMeIu0l", name: "number_of_results", value: properties.numberOfResults});
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "a25cb249-d421-4a79-ad74-93925ee63ddd", "af3e3991f0188d5ab4dcda89cc5ec42ac196e64af5f38eb4796d761e1742760b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_debate_topics_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("a25cb249-d421-4a79-ad74-93925ee63ddd", "ai_tools_debate_topics_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_debate_topics_create", eventProperties, "a25cb249-d421-4a79-ad74-93925ee63ddd", "af3e3991f0188d5ab4dcda89cc5ec42ac196e64af5f38eb4796d761e1742760b");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_debate_topics_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_debate_topics_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_debate_topics_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsTaskCreateProperties {
  educationalLevel: string;
  taskType: string;
  taskDuration: number;
  allowedResources: string[];
  assignmentFormat: string[];
  lessonAsInput: boolean;
  promptLength: number;
  languageOutput: string;
}
/**
 * ai_tools_task_create: User successfully generated an assignment.
 * 
 * @param properties the properties associatied with this event
 * @param properties.educationalLevel: The educational level the generated output needs to adhere to.

 * @param properties.taskType: The type of assignment that is generated.
 * @param properties.taskDuration: Duration how long the assignment should take.
 * @param properties.allowedResources: The type of resources that students are allowed to use.
 * @param properties.assignmentFormat: The type of format the assignment needs to adhere to.
 * @param properties.lessonAsInput: Indicate whether the input that is used is based on a LessonUp lesson. True = yes.
 * @param properties.promptLength: The number of characters of the text prompt
 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/5fcb018f-2dfb-46f0-9bbc-a9126a3ec2d6}
 */
export function aiToolsTaskCreate(properties: AiToolsTaskCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "Rdt6wSGJ3BclL7pojoeoA", name: "educational_level", value: properties.educationalLevel});
eventPropertiesArray.push({id: "58GITFJhL2dG4M6Fh_Lsw", name: "task_type", value: properties.taskType});
eventPropertiesArray.push({id: "KfxZ4I8lFs3D_09LuGEbT", name: "task_duration", value: properties.taskDuration});
eventPropertiesArray.push({id: "UdX7_V2iZ61W6zRRNQei7", name: "allowed_resources", value: properties.allowedResources});
eventPropertiesArray.push({id: "xGxW2Z2ulRRuWcD3H1wZn", name: "assignment_format", value: properties.assignmentFormat});
eventPropertiesArray.push({id: "jaXE5ABxGERPcMgoO_4Hd", name: "lesson_as_input", value: properties.lessonAsInput});
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "5fcb018f-2dfb-46f0-9bbc-a9126a3ec2d6", "a331d31ae66f15dfb4f29d3ddb37a5cd407af93cebb74729e9c8f09d0cd7b949", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_task_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("5fcb018f-2dfb-46f0-9bbc-a9126a3ec2d6", "ai_tools_task_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_task_create", eventProperties, "5fcb018f-2dfb-46f0-9bbc-a9126a3ec2d6", "a331d31ae66f15dfb4f29d3ddb37a5cd407af93cebb74729e9c8f09d0cd7b949");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_task_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_task_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_task_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsLessonRecapProperties {
  summaryLength: string;
  languageOutput: string;
}
/**
 * ai_tools_lesson_recap: User clicks the generate button to recap a lesson.
 * 
 * @param properties the properties associatied with this event
 * @param properties.summaryLength: The length that is used to generate the summary.
 * @param properties.languageOutput: The output language of the ai generated slides
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/7680a02c-c415-4283-af93-27940b4ad96e}
 */
export function aiToolsLessonRecap(properties: AiToolsLessonRecapProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "7f7oeAljjIPlTQLohGWQE", name: "summary_length", value: properties.summaryLength});
eventPropertiesArray.push({id: "46Sa5ToQc", name: "language_output", value: properties.languageOutput});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "7680a02c-c415-4283-af93-27940b4ad96e", "6230ab7d26e27e7542ea303a10b2c36c8ffab8de6c934ab1f387f3c2575bf84c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_lesson_recap", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("7680a02c-c415-4283-af93-27940b4ad96e", "ai_tools_lesson_recap", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_lesson_recap", eventProperties, "7680a02c-c415-4283-af93-27940b4ad96e", "6230ab7d26e27e7542ea303a10b2c36c8ffab8de6c934ab1f387f3c2575bf84c");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_lesson_recap", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_lesson_recap", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_lesson_recap", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsCopyProperties {
  aiToolType: AiToolTypeValueType;
}
/**
 * ai_tools_copy: User copies the generated output.
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiToolType: The type of ai tool used
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/28aa768f-3b3e-4a9b-ba10-300860d26858}
 */
export function aiToolsCopy(properties: AiToolsCopyProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RJNtfoJaSyYeHq4MBNIOV", name: "ai_tool_type", value: properties.aiToolType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "28aa768f-3b3e-4a9b-ba10-300860d26858", "b8a1771934e7ce2d3437e9f4c66e5ae8563be665a1b2740eb6b813cf24456dc1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_copy", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("28aa768f-3b3e-4a9b-ba10-300860d26858", "ai_tools_copy", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_copy", eventProperties, "28aa768f-3b3e-4a9b-ba10-300860d26858", "b8a1771934e7ce2d3437e9f4c66e5ae8563be665a1b2740eb6b813cf24456dc1");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_copy", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_copy", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_copy", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsImageCreateProperties {
  promptLength: number;
  educationalLevel: string;
  educationalPurpose: string;
  imageStyle: string;
  detailedStyle: string;
  specificDetails: boolean | null | undefined;
  aspectRatio: string;
}
/**
 * ai_tools_image_create: User successfully creates an image
 * 
 * @param properties the properties associatied with this event
 * @param properties.promptLength: The number of characters of the text prompt
 * @param properties.educationalLevel: The educational level the generated output needs to adhere to.

 * @param properties.educationalPurpose: User chooses the educational purposed for the image
 * @param properties.imageStyle: User chooses the style of the image to generate
 * @param properties.detailedStyle: User optionally chooses to describe a detailed style for the generated image
 * @param properties.specificDetails: Indicate if the user added specific details in the open input field.
 * @param properties.aspectRatio: Indicate the chosen aspect ratio for the created image
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/0mZoxvy1DyDcm6yQqpmOC}
 */
export function aiToolsImageCreate(properties: AiToolsImageCreateProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "hexFks8ozU", name: "prompt_length", value: properties.promptLength});
eventPropertiesArray.push({id: "Rdt6wSGJ3BclL7pojoeoA", name: "educational_level", value: properties.educationalLevel});
eventPropertiesArray.push({id: "_oV_gEjVdaNp6xHok7tVa", name: "educational_purpose", value: properties.educationalPurpose});
eventPropertiesArray.push({id: "uZEimQYqCO_ZbzudIkP8g", name: "image_style", value: properties.imageStyle});
eventPropertiesArray.push({id: "tnZJr0Hvnr9V2gsED0sJ5", name: "detailed_style", value: properties.detailedStyle});
properties.specificDetails !== undefined && properties.specificDetails !== null ?
  eventPropertiesArray.push({id: "4yZ9AhsPFaM_DyLmYl1Yp", name: "specific_details", value: properties.specificDetails}) :
  eventPropertiesArray.push({id: "4yZ9AhsPFaM_DyLmYl1Yp", name: "specific_details", value: null});
eventPropertiesArray.push({id: "rqCIC_y-mJiGNudMW71z8", name: "aspect_ratio", value: properties.aspectRatio});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "0mZoxvy1DyDcm6yQqpmOC", "40bcb032751901377322df537fba1774ed27253c9902e206a564e93555e75d7e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_image_create", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("0mZoxvy1DyDcm6yQqpmOC", "ai_tools_image_create", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_image_create", eventProperties, "0mZoxvy1DyDcm6yQqpmOC", "40bcb032751901377322df537fba1774ed27253c9902e206a564e93555e75d7e");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_image_create", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_image_create", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_image_create", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsThumbsUpProperties {
  aiToolType: AiToolTypeValueType;
}
/**
 * ai_tools_thumbs_up: User clicks on thumbs up for the generated output
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiToolType: The type of ai tool used
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/ggJqg3jHXjGo9UY7yPF2m}
 */
export function aiToolsThumbsUp(properties: AiToolsThumbsUpProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RJNtfoJaSyYeHq4MBNIOV", name: "ai_tool_type", value: properties.aiToolType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "ggJqg3jHXjGo9UY7yPF2m", "9050a49a1b49a66cb35a83c398e5146fd1d36269a124f1c564ed26827c4b9dbd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_thumbs_up", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("ggJqg3jHXjGo9UY7yPF2m", "ai_tools_thumbs_up", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_thumbs_up", eventProperties, "ggJqg3jHXjGo9UY7yPF2m", "9050a49a1b49a66cb35a83c398e5146fd1d36269a124f1c564ed26827c4b9dbd");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_thumbs_up", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_thumbs_up", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_thumbs_up", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsThumbsDownProperties {
  aiToolType: AiToolTypeValueType;
}
/**
 * ai_tools_thumbs_down: User clicks on thumbs down for the generated output
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiToolType: The type of ai tool used
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/0e8df579-03c4-45cc-9623-513a4ca43489}
 */
export function aiToolsThumbsDown(properties: AiToolsThumbsDownProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RJNtfoJaSyYeHq4MBNIOV", name: "ai_tool_type", value: properties.aiToolType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "0e8df579-03c4-45cc-9623-513a4ca43489", "6d6a0b14ad7d4464a4e8ab67a73b3f2269c0341decc22a9e5c10093a9138ac8f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_thumbs_down", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("0e8df579-03c4-45cc-9623-513a4ca43489", "ai_tools_thumbs_down", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_thumbs_down", eventProperties, "0e8df579-03c4-45cc-9623-513a4ca43489", "6d6a0b14ad7d4464a4e8ab67a73b3f2269c0341decc22a9e5c10093a9138ac8f");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_thumbs_down", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_thumbs_down", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_thumbs_down", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsThumbsUpCancelProperties {
  aiToolType: AiToolTypeValueType;
}
/**
 * ai_tools_thumbs_up_cancel: User clicks the enabled thumbs up icon to cancel the thumbs up event.
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiToolType: The type of ai tool used
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/hZtUltMJyXaef7J2z5D6_}
 */
export function aiToolsThumbsUpCancel(properties: AiToolsThumbsUpCancelProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RJNtfoJaSyYeHq4MBNIOV", name: "ai_tool_type", value: properties.aiToolType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "hZtUltMJyXaef7J2z5D6_", "f82c9a20a53b0cafbe4426e061e87ad444bd7b99acf0762224581bb1f77e5f34", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_thumbs_up_cancel", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("hZtUltMJyXaef7J2z5D6_", "ai_tools_thumbs_up_cancel", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_thumbs_up_cancel", eventProperties, "hZtUltMJyXaef7J2z5D6_", "f82c9a20a53b0cafbe4426e061e87ad444bd7b99acf0762224581bb1f77e5f34");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_thumbs_up_cancel", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_thumbs_up_cancel", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_thumbs_up_cancel", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsThumbsDownCancelProperties {
  aiToolType: AiToolTypeValueType;
}
/**
 * ai_tools_thumbs_down_cancel: User clicks the enabled thumbs down icon to cancel the thumbs down event.
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiToolType: The type of ai tool used
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/gm66ytNHm3GX9D_eHzTeX}
 */
export function aiToolsThumbsDownCancel(properties: AiToolsThumbsDownCancelProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RJNtfoJaSyYeHq4MBNIOV", name: "ai_tool_type", value: properties.aiToolType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "gm66ytNHm3GX9D_eHzTeX", "1545092d91b23acfb86226887ee033d0e7e052039598ddf8d52a3f11f95523b7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_thumbs_down_cancel", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("gm66ytNHm3GX9D_eHzTeX", "ai_tools_thumbs_down_cancel", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_thumbs_down_cancel", eventProperties, "gm66ytNHm3GX9D_eHzTeX", "1545092d91b23acfb86226887ee033d0e7e052039598ddf8d52a3f11f95523b7");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_thumbs_down_cancel", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_thumbs_down_cancel", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_thumbs_down_cancel", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsUseInLessonModalProperties {
  aiToolType: AiToolTypeValueType;
}
/**
 * ai_tools_use_in_lesson_modal: User clicks on "use in lesson" after generated output
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiToolType: The type of ai tool used
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/yKgCMmZNbSgSNGdUwHzin}
 */
export function aiToolsUseInLessonModal(properties: AiToolsUseInLessonModalProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RJNtfoJaSyYeHq4MBNIOV", name: "ai_tool_type", value: properties.aiToolType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "yKgCMmZNbSgSNGdUwHzin", "8c2bc4cb18bf32d3b6aa05e7439867f55e3b0d7370316c80e2c4314c77921580", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_use_in_lesson_modal", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("yKgCMmZNbSgSNGdUwHzin", "ai_tools_use_in_lesson_modal", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_use_in_lesson_modal", eventProperties, "yKgCMmZNbSgSNGdUwHzin", "8c2bc4cb18bf32d3b6aa05e7439867f55e3b0d7370316c80e2c4314c77921580");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_use_in_lesson_modal", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_use_in_lesson_modal", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_use_in_lesson_modal", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsUseInLessonCopySlideProperties {
  aiToolType: AiToolTypeValueType;
}
/**
 * ai_tools_use_in_lesson_copy_slide: User clicks on "Copy slide" to copy the generated output as a slide.
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiToolType: The type of ai tool used
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/nOJ7W1gOPs7U0ol37qkoJ}
 */
export function aiToolsUseInLessonCopySlide(properties: AiToolsUseInLessonCopySlideProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RJNtfoJaSyYeHq4MBNIOV", name: "ai_tool_type", value: properties.aiToolType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "nOJ7W1gOPs7U0ol37qkoJ", "5e43e6864d79d1272d1d90179fc6407d446a7726a0ae9c3df70f6f2998f29d96", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_use_in_lesson_copy_slide", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("nOJ7W1gOPs7U0ol37qkoJ", "ai_tools_use_in_lesson_copy_slide", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_use_in_lesson_copy_slide", eventProperties, "nOJ7W1gOPs7U0ol37qkoJ", "5e43e6864d79d1272d1d90179fc6407d446a7726a0ae9c3df70f6f2998f29d96");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_use_in_lesson_copy_slide", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_use_in_lesson_copy_slide", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_use_in_lesson_copy_slide", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export interface AiToolsUseInLessonCreateNewLessonProperties {
  aiToolType: AiToolTypeValueType;
}
/**
 * ai_tools_use_in_lesson_create_new_lesson: User clicks on "Use in new lesson" to create a new lesson for the generated output.
 * 
 * @param properties the properties associatied with this event
 * @param properties.aiToolType: The type of ai tool used
 * 
 * @see {@link https://www.avo.app/schemas/aDA1SfVA6aXQablIZ7vn/events/F1X1W8yJJYEBoz2_p0W-o}
 */
export function aiToolsUseInLessonCreateNewLesson(properties: AiToolsUseInLessonCreateNewLessonProperties) {
// @ts-ignore
let eventPropertiesArray: array = [];
eventPropertiesArray.push({id: "RJNtfoJaSyYeHq4MBNIOV", name: "ai_tool_type", value: properties.aiToolType});
let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
// @ts-ignore
let userPropertiesArray: array = [];
let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
// assert properties
if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
  let messages: AvoAssertMessage[] = [];
  // debug console in Avo
  if (!__AVO_NOOP__) {
    _avo_invoke(__AVO_ENV__, "F1X1W8yJJYEBoz2_p0W-o", "cb2d6656df219be8a66400cb653f32437f874dd6d5a0d245d5efb8d39142dd91", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
}
InternalAvoLogger.logEventSent("ai_tools_use_in_lesson_create_new_lesson", eventProperties, userProperties);
if (__WEB_DEBUGGER__) {
  // Avo web debugger
  _avo_debugger_log("F1X1W8yJJYEBoz2_p0W-o", "ai_tools_use_in_lesson_create_new_lesson", messages, eventPropertiesArray, userPropertiesArray, []);
}
}
if (!__AVO_NOOP__) {
  if (__INSPECTOR__ != null) {
    // @ts-ignore
    __INSPECTOR__._avoFunctionTrackSchemaFromEvent("ai_tools_use_in_lesson_create_new_lesson", eventProperties, "F1X1W8yJJYEBoz2_p0W-o", "cb2d6656df219be8a66400cb653f32437f874dd6d5a0d245d5efb8d39142dd91");
}
// destination SnowplowCustom
SnowplowCustom.logEvent("ai_tools_use_in_lesson_create_new_lesson", (Object as any).assign({}, eventProperties));

// destination GoogleAnalytics4
GoogleAnalytics4.logEvent("ai_tools_use_in_lesson_create_new_lesson", (Object as any).assign({}, eventProperties));

// destination MicrosoftUET
MicrosoftUET.logEvent("ai_tools_use_in_lesson_create_new_lesson", (Object as any).assign({}, eventProperties));
} else {
  // do nothing
}
}

export default {
  AvoEnv,
  initAvo,
  avoInspectorApiKey,
  FileType,
  PinComponentType,
  PinType,
  EditorVersion,
  PinCreationMethod,
  MobileRedirectionChoice,
  AiToolType,
  SelectedPurpose,
  AiInputMethod,
  LoginMethod,
  RequestToJoinMethod,
  GeneratorInputMethod,
  PlayerComponentType,
  OrganizationMatchMethod,
  PinComponentCreationMethod,
  registrationStart,
  registrationUserSchoolChangeForm,
  createRegistrationAccount,
  subscriptionStart,
  subscriptionSubtypeSelect,
  lessonCreate,
  lessonTeach,
  lessonStopPresenting,
  lessonSaveForLater,
  registrationCompleted,
  teamsBetaOpenForm,
  lessonView,
  lessonShare,
  lessonRename,
  pinView,
  reportOpen,
  testGrade,
  lessonOpen,
  pinOpen,
  sessionLockView,
  teamsBetaShowForm,
  organizationRequestToJoinAccepted,
  organizationInviteToJoinSent,
  organizationLicenseGiven,
  organizationRequestToJoinRejected,
  organizationMembershipRemoved,
  organizationLicenseRemoved,
  teacherRequestToJoinOrganizationSent,
  teacherRequestToJoinOrganizationCanceled,
  organizationLicensePurchased,
  organizationMatchSuggested,
  teacherRegistrationPurposeSelected,
  onboardingLessonDemoPrompted,
  onboardingLessonDemoStarted,
  onboardingLessonDemoClosed,
  mobileRedirectionReaction,
  pinCreate,
  teacherRegistrationHardPrompt,
  teacherRegistrationMediumPrompt,
  experimentAiGenerationStarted,
  experimentAiGenerationFailed,
  experimentAiGenerationSuccess,
  experimentAiGenerationPromptSuccess,
  experimentAiGenerationPromptDiscarded,
  experimentAiLessonGenerationFailed,
  experimentAiLessonGenerationSuccess,
  experimentAiLessonGenerationStarted,
  experimentAiLessonGenerationPromptDiscarded,
  experimentAiLessonPromptSuccess,
  upload,
  lessonGeneratorOpened,
  lessonGeneratorOutlineGenerated,
  lessonGeneratorOutlineGenerationFailed,
  lessonGeneratorOverviewGenerated,
  lessonGeneratorOverviewGenerationFailed,
  lessonGeneratorLessonCreated,
  referralModalOpened,
  referralLinkCopied,
  aiStart,
  aiOpened,
  aiLessonPreview,
  aiLessonStructure,
  aiError,
  aiLessonCreated,
  lessonClickPowerpoint,
  lessonPowerpointConverted,
  lessonPowerpointStartConversion,
  registrationVerificationStart,
  registrationVerificationSuccessful,
  registrationVerificationLinkExpired,
  registrationPasswordCreated,
  registrationError,
  teacherLogin,
  pinComponentCreate,
  lessonPresenterMode,
  studentNavigateToApp,
  spinnerSpin,
  playerComponentCreate,
  spinnerReset,
  aiToolsTextSummarize,
  aiToolsWebsiteSummarize,
  aiToolsTextTranslate,
  aiToolsTextRewrite,
  aiToolsRubricCreate,
  aiToolsGlossaryCreate,
  aiToolsDebateTopicsCreate,
  aiToolsTaskCreate,
  aiToolsLessonRecap,
  aiToolsCopy,
  aiToolsImageCreate,
  aiToolsThumbsUp,
  aiToolsThumbsDown,
  aiToolsThumbsUpCancel,
  aiToolsThumbsDownCancel,
  aiToolsUseInLessonModal,
  aiToolsUseInLessonCopySlide,
  aiToolsUseInLessonCreateNewLesson,
}

// AVOMODULEMAP:"AvoGenerated"
// AVOEVENTMAP:["registrationStart","registrationUserSchoolChangeForm","createRegistrationAccount","subscriptionStart","subscriptionSubtypeSelect","lessonCreate","lessonTeach","lessonStopPresenting","lessonSaveForLater","registrationCompleted","teamsBetaOpenForm","lessonView","lessonShare","lessonRename","pinView","reportOpen","testGrade","lessonOpen","pinOpen","sessionLockView","teamsBetaShowForm","organizationRequestToJoinAccepted","organizationInviteToJoinSent","organizationLicenseGiven","organizationRequestToJoinRejected","organizationMembershipRemoved","organizationLicenseRemoved","teacherRequestToJoinOrganizationSent","teacherRequestToJoinOrganizationCanceled","organizationLicensePurchased","organizationMatchSuggested","teacherRegistrationPurposeSelected","onboardingLessonDemoPrompted","onboardingLessonDemoStarted","onboardingLessonDemoClosed","mobileRedirectionReaction","pinCreate","teacherRegistrationHardPrompt","teacherRegistrationMediumPrompt","experimentAiGenerationStarted","experimentAiGenerationFailed","experimentAiGenerationSuccess","experimentAiGenerationPromptSuccess","experimentAiGenerationPromptDiscarded","experimentAiLessonGenerationFailed","experimentAiLessonGenerationSuccess","experimentAiLessonGenerationStarted","experimentAiLessonGenerationPromptDiscarded","experimentAiLessonPromptSuccess","upload","lessonGeneratorOpened","lessonGeneratorOutlineGenerated","lessonGeneratorOutlineGenerationFailed","lessonGeneratorOverviewGenerated","lessonGeneratorOverviewGenerationFailed","lessonGeneratorLessonCreated","referralModalOpened","referralLinkCopied","aiStart","aiOpened","aiLessonPreview","aiLessonStructure","aiError","aiLessonCreated","lessonClickPowerpoint","lessonPowerpointConverted","lessonPowerpointStartConversion","registrationVerificationStart","registrationVerificationSuccessful","registrationVerificationLinkExpired","registrationPasswordCreated","registrationError","teacherLogin","pinComponentCreate","lessonPresenterMode","studentNavigateToApp","spinnerSpin","playerComponentCreate","spinnerReset","aiToolsTextSummarize","aiToolsWebsiteSummarize","aiToolsTextTranslate","aiToolsTextRewrite","aiToolsRubricCreate","aiToolsGlossaryCreate","aiToolsDebateTopicsCreate","aiToolsTaskCreate","aiToolsLessonRecap","aiToolsCopy","aiToolsImageCreate","aiToolsThumbsUp","aiToolsThumbsDown","aiToolsThumbsUpCancel","aiToolsThumbsDownCancel","aiToolsUseInLessonModal","aiToolsUseInLessonCopySlide","aiToolsUseInLessonCreateNewLesson"]
